// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 固定配置,存于本地代码中
import { getDjCategory } from '@/views/ztbj/djbj/dj_config'
import { getActionCategory } from '@/views/ztbj/djbj/action_config'
import { getLogicCategory } from '@/views/ztbj/djbj/logic_config'
// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
import { v4 as uuidv4 } from 'uuid'
import FileSaver from 'file-saver'
import store from '@/store'
// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
import * as api_boarddata from '@/api/boarddata'
import { forEach } from 'lodash'

// Added for gzip post @2025-4-17
import GzipWorker from '@/workers/gzip.worker.js'

// 保存原始的 console.log
const originalLog = console.log;

// 重写 console.log 添加时间戳
console.log = function(...args) {
  const timestamp = new Date().toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    fractionalSecondDigits: 3
  });
  originalLog(`[${timestamp}]`, ...args);
};

// 如果需要，也可以重写其他 console 方法
console.error = function(...args) {
  const timestamp = new Date().toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    fractionalSecondDigits: 3
  });
  originalLog(`[${timestamp}] ❌`, ...args);
};

console.warn = function(...args) {
  const timestamp = new Date().toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    fractionalSecondDigits: 3
  });
  originalLog(`[${timestamp}] ⚠️`, ...args);
};

console.info = function(...args) {
  const timestamp = new Date().toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    fractionalSecondDigits: 3
  });
  originalLog(`[${timestamp}] ℹ️`, ...args);
};

function _refreshStorage_old(gurantee) {
  state.action_cell_all = []
  state.action_list_all = []

  state.logic_cell_all = []
  state.logic_unit_all = []

  state.action_cells = []
  state.action_list = []
  state.check_action_list = []

  state.logic_cells = []
  state.logic_units = []
  state.logic_groups = []

  _guranteeVitualDevice()

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // 收集设备中的action/logic到pool中
  if (!_.isEmpty(state.active_theme._deviceArr)) {
    state.active_theme._deviceArr.forEach((eleDevice, idx, arr) => {
      // GUOJIULIN  2023-2-7
      // 根据最新的配置，更新device的action 和logic
      if (gurantee > 0) {
        _guranteeDeviceInfo(eleDevice)
      }

      // console.log('Refresh Action ', idx)
      if (!_.isEmpty(eleDevice._action_cells)) {
        eleDevice._action_cells.forEach((eleActionCell, idx, arr) => {
          _noDupPush(state.action_cell_all, eleActionCell)
          console.log('eleActionCell ', eleActionCell)
          _noDupPush(state.action_list_all, eleActionCell._action_list)
        })
      }
      // console.log('Refresh Logic ', idx)
      if (!_.isEmpty(eleDevice._logic_cells)) {
        eleDevice._logic_cells.forEach((eleLogicCell, idx, arr) => {
          _noDupPush(state.logic_cell_all, eleLogicCell)
          _noDupPush(state.logic_unit_all, eleLogicCell._logic_unit)
        })
      }
    })
  }

  console.log('>>> state.action_list_all', state.action_list_all)

  let filterRst_arrLogicCell = state.logic_cell_all.filter((eleLogicCell, idxLogicCell, arrLogicCell) => {
    return eleLogicCell.device_type == 3 && eleLogicCell.device_id == 11
  })

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
}


function _refreshStorage(gurantee) {
  // 清空各类池
  state.action_cell_all = []
  state.action_list_all = []

  state.logic_cell_all = []
  state.logic_unit_all = []

  state.action_cells = []
  state.action_list = []
  state.check_action_list = []

  state.logic_cells = []
  state.logic_units = []
  state.logic_groups = []

  _guranteeVitualDevice()

  const tmpActionCells = []
  const tmpActionList = []
  const tmpLogicCells = []
  const tmpLogicUnits = []

  if (!_.isEmpty(state.active_theme._deviceArr)) {
    state.active_theme._deviceArr.forEach((eleDevice, idx) => {
      // 保证设备结构
      if (gurantee > 0) {
        _guranteeDeviceInfo(eleDevice)
      }

      // 收集 action_cell 和 _action_list
      if (!_.isEmpty(eleDevice._action_cells)) {
        eleDevice._action_cells.forEach(actionCell => {
          tmpActionCells.push(actionCell)

          const list = actionCell._action_list
          if (Array.isArray(list)) {
            tmpActionList.push(...list)
          } else if (_.isObject(list)) {
            tmpActionList.push(list)
          }
        })
      }

      // 收集 logic_cell 和 _logic_unit
      if (!_.isEmpty(eleDevice._logic_cells)) {
        eleDevice._logic_cells.forEach(logicCell => {
          tmpLogicCells.push(logicCell)

          const unit = logicCell._logic_unit
          if (Array.isArray(unit)) {
            tmpLogicUnits.push(...unit)
          } else if (_.isObject(unit)) {
            tmpLogicUnits.push(unit)
          }
        })
      }
    })
  }

  // 合并入 state 并去重
  appendUniqueByGuid(state.action_cell_all, tmpActionCells)
  appendUniqueByGuid(state.action_list_all, tmpActionList, 'action_list_guid')

  appendUniqueByGuid(state.logic_cell_all, tmpLogicCells)
  appendUniqueByGuid(state.logic_unit_all, tmpLogicUnits, 'logic_unit_guid')
}

function appendUniqueByGuid(targetPool, sourceItems, guidKey = null) {
  if (!Array.isArray(sourceItems)) return

  const existingGuidSet = new Set()

  for (const item of targetPool) {
    const key = guidKey || Object.keys(item).find(k => k.includes('_guid'))
    if (key && item[key]) {
      existingGuidSet.add(item[key])
    }
  }

  for (const item of sourceItems) {
    const key = guidKey || Object.keys(item).find(k => k.includes('_guid'))
    if (!key || !item[key]) continue

    if (!existingGuidSet.has(item[key])) {
      targetPool.push(item)
      existingGuidSet.add(item[key])
    }
  }
}

// 更新device的action
function _guranteeActionCell(device) {
  let this_map_action_category = state.map_action_category.get(parseInt(device.device_type))
  if (_.isNil(this_map_action_category)) {
    return
  }
  this_map_action_category.action_types.forEach((eleActionType, idx, arr) => {
    let doAdd = 1

    device._action_cells.forEach((eleDeviceAction, idx, arr) => {
      // 这里要去重，已有的动作类型不再追加
      if (eleDeviceAction.device_op === eleActionType.action_value) {
        doAdd = 0
      }
    })

    if (doAdd > 0) {
      let action_cell = {
        action_cell_guid: uuidv4().toUpperCase(),
        action_cell_name: device.device_name + ' ' + eleActionType.action_name,
        action_cell_desc: '',
        action_cell_id: _gen_action_cell_id(),

        device_type: device.device_type,

        device_id: device.device_id,
        _GUID_device_id: device.device_guid,

        device_op: eleActionType.action_value,

        param: 0,
        _param_enable: eleActionType.action_param,
        // 高级param编辑功能预留
        param_addtion: '',
        _param_hint: eleActionType.action_param_hint,
        _param_name: eleActionType.action_param_name,
        _param_edit_mode: eleActionType.action_param_mode,
        _isInEdit: false,

        // * 仅当 action cell的type=39
        // >>>1964>>> 2023-5-30
        _param_value_uid: null,  // 用于场景选择
        _isInEdit: false,
      }
      console.log('Device ', device, 'Add action ', action_cell)

      _noDupPush(device._action_cells, action_cell)
      _noDupPush(state.action_cell_all, action_cell)
    } else {
      // Fix issue 2377 @2025-02-22
      // Refresh action name
      let foundAction = device._action_cells.find((eleDeviceAction, idx, arr) => {
        return eleDeviceAction.device_op === eleActionType.action_value
      })
      if (!_.isUndefined(foundAction)) {
        foundAction.action_cell_name = device.device_name + ' ' + eleActionType.action_name
      }

      let foundAction2 = state.action_cell_all.find((eleDeviceAction, idx, arr) => {
        // 注意，从池子里面找到的action_cell，需要根据device_id和device_type来判断
        return eleDeviceAction.device_op === eleActionType.action_value && eleDeviceAction.device_id === device.device_id && eleDeviceAction.device_type === device.device_type
      }
      )
      if (!_.isUndefined(foundAction2)) {
        foundAction2.action_cell_name = device.device_name + ' ' + eleActionType.action_name
      }
    }
  })
}

// 更新device的logic
function _guranteeLogicCell(device) {
  let this_map_logic_category = state.map_logic_category.get(parseInt(device.device_type))
  if (_.isNil(this_map_logic_category)) {
    return
  }

  this_map_logic_category.logic_types.forEach((eleLogicType, idx, arr) => {
    let doAdd = 1
    device._logic_cells.forEach((eleDeviceLogic, idx, arr) => {
      // 这里要去重，已有的逻辑类型不再追加
      if (eleDeviceLogic.logic_type === eleLogicType.logic_value) {
        doAdd = 0
      }
    })

    if (doAdd > 0) {
      let logic_cell = {
        logic_cell_guid: uuidv4().toUpperCase(),
        logic_cell_name: device.device_name + ' ' + eleLogicType.logic_name,
        logic_cell_id: _gen_logic_cell_id(),

        device_type: device.device_type,

        device_id: device.device_id,
        _GUID_device_id: device.device_guid,

        logic_type: eleLogicType.logic_value,

        param: 0,
        _param_enable: eleLogicType.param_enable,

        _isInEdit: false,

        _afterRelation: 0xdead, // 0xdead:且, 0xbeef:或
      }

      // DUKU 还是要生成,因为同一logicCell的unit会被复用
      _gen_logic_unit(logic_cell)

      _noDupPush(device._logic_cells, logic_cell)
      _noDupPush(state.logic_cell_all, logic_cell)
    } else {
      // Fix issue 2377 @2025-02-22
      // Refresh logic name

      let foundLogic = device._logic_cells.find((eleDeviceLogic, idx, arr) => {
        return eleDeviceLogic.logic_type === eleLogicType.logic_value
      })

      if (!_.isUndefined(foundLogic)) {
        foundLogic.logic_cell_name = device.device_name + ' ' + eleLogicType.logic_name
      }

      let foundLogic2 = state.logic_cell_all.find((eleDeviceLogic, idx, arr) => {
        // 注意，从池子里面找到的action_cell，需要根据device_id和device_type来判断
        return eleDeviceLogic.logic_type === eleLogicType.logic_value && eleDeviceLogic.device_id === device.device_id && eleDeviceLogic.device_type === device.device_type
      })

      if (!_.isUndefined(foundLogic2)) {
        foundLogic2.logic_cell_name = device.device_name + ' ' + eleLogicType.logic_name
      }
    }
  })
}

function _guranteeDeviceInfo(device) {
  // _guranteeDevice fields
  if (device && device.device_type === 4) {
    if (!device.hasOwnProperty('msCtrl')) {
      // console.log('Add msCtrl to device', device)
      device.msCtrl = 0;
    } else {
      // console.log('msCtrl in device', device)
    }
  }

  _guranteeActionCell(device)
  _guranteeLogicCell(device)
}

function _guranteeVitualDevice() {
  // console.log(state.active_theme._deviceArr)

  for (let device_type = 30; device_type < 41; device_type++) {
    let foundIdx_device = state.active_theme._deviceArr.findIndex((eleDevice, idxDevice, arrDevice) => {
      return eleDevice.device_type == device_type
    })

    if (foundIdx_device !== -1) {
      // 找到了!
      if (device_type == 31) {
        // 始终执行
        _noDupPush(state.logic_cells, state.active_theme._deviceArr[foundIdx_device]._logic_cells[0])
        _noDupPush(state.logic_units, state.active_theme._deviceArr[foundIdx_device]._logic_cells[0]._logic_unit)
      } else if (device_type == 32) {
        // 跳关
        _noDupPush(state.action_cells, state.active_theme._deviceArr[foundIdx_device]._action_cells[0])
        _noDupPush(state.action_list, state.active_theme._deviceArr[foundIdx_device]._action_cells[0]._action_list)
      } else if (device_type == 30) {
        // 任务
        // 数量升级
      }
    } else {
      // 没找到
      _genVirtualDevice(device_type)
    }
  }

  _expandTaskNumber()
}

function _expandTaskNumber() {
  // 已有任务数量
  console.log('_expandTaskNumber')
  let currentMaxTask = 1

  let taskDevices = state.active_theme._deviceArr.filter((eleDevice, eleIndex, elelArr) => {
    return eleDevice.device_type == 30
  })

  if (!_.isEmpty(taskDevices)) {
    // console.log(taskDevices)
    taskDevices.forEach((ele, index, arr) => {
      if (ele.device_id > currentMaxTask ) {
        currentMaxTask = ele.device_id
      }
    })
  }

  console.log('currentMaxTask' , currentMaxTask)
  // 扩展
  for (let idx_ = currentMaxTask+1; idx_ <= 128; idx_++) {
    let newDevice = _genDeviceFixed_task(30, idx_)

    if (!_.isEmpty(newDevice)) {
      _expand_device_info(newDevice)
      _noDupPush(state.active_theme._deviceArr, newDevice)
    }
  }
}

// /*FUN*/ _genVirtualDevice
function _genVirtualDevice(device_type) {
  if (device_type == 30) {
    // 任务
    for (let idx_ = 1; idx_ <= 128; idx_++) {
      let newDevice = _genDeviceFixed_task(device_type, idx_)

      if (!_.isEmpty(newDevice)) {
        _expand_device_info(newDevice)
        _noDupPush(state.active_theme._deviceArr, newDevice)
      }
    }
  } else {
    let newDevice = _genDeviceFixed(device_type)

    if (!_.isEmpty(newDevice)) {
      _expand_device_info(newDevice)
      _noDupPush(state.active_theme._deviceArr, newDevice)

      if (device_type == 31) {
        // 始终执行
        _noDupPush(state.logic_cells, newDevice._logic_cells[0])
        _noDupPush(state.logic_units, newDevice._logic_cells[0]._logic_unit)
      } else if (device_type == 32 || device_type == 40) {
        // 跳关
        _noDupPush(state.action_cells, newDevice._action_cells[0])

        _gen_action_list(newDevice._action_cells[0])
        _noDupPush(state.action_list, newDevice._action_cells[0]._action_list)
      }
    }
  }
}

function _genDeviceFixed(device_type) {
  let dj_category_this = state.map_dj_category.get(parseInt(device_type))
  if (_.isNil(dj_category_this)) {
    return
  }

  let device_id = _gen_devcie_id(device_type)

  let newDevice = {
    device_guid: uuidv4().toUpperCase(),
    device_name: dj_category_this.name_,
    device_desc: '',
    device_type: parseInt(device_type),
    device_id: device_id,

    _action_cells: [],
    _logic_cells: [],
  }

  if (_.isArray(dj_category_this.proplist) && !_.isEmpty(dj_category_this.proplist)) {
    dj_category_this.proplist.forEach(eleProp => {
      newDevice[eleProp.field_name] = null
    })
  }

  return newDevice
}

function _genDeviceFixed_task(device_type, num) {
  let dj_category_this = state.map_dj_category.get(parseInt(device_type))
  if (_.isNil(dj_category_this)) {
    return
  }

  let newDevice = {
    device_guid: uuidv4().toUpperCase(),
    device_name: dj_category_this.name_ + num,
    device_desc: '',
    device_type: parseInt(device_type),
    device_id: num,

    _action_cells: [],
    _logic_cells: [],
  }

  if (_.isArray(dj_category_this.proplist) && !_.isEmpty(dj_category_this.proplist)) {
    dj_category_this.proplist.forEach(eleProp => {
      newDevice[eleProp.field_name] = null
    })
  }

  return newDevice
}

function _genDevice(device_type) {
  let dj_category_this = state.map_dj_category.get(parseInt(device_type))
  if (_.isNil(dj_category_this)) {
    return
  }

  let device_id = _gen_devcie_id(device_type)

  let newDevice = {
    device_guid: uuidv4().toUpperCase(),
    device_name: dj_category_this.name_ + ' ' + device_id,
    device_desc: '',
    device_type: parseInt(device_type),
    device_id: device_id,

    _action_cells: [],
    _logic_cells: [],
    isUsed: false,
  }

  if (_.isArray(dj_category_this.proplist) && !_.isEmpty(dj_category_this.proplist)) {
    dj_category_this.proplist.forEach((eleProp, idx, arr) => {
      // newDevice[eleProp.field_name] = null
      newDevice[eleProp.field_name] = eleProp.default_value

      if (eleProp.field_name == 'device_net_id') {
        newDevice[eleProp.field_name] = newDevice.device_id
      }

      //  if (eleProp.field_name == 'netdev_id') {
      //   newDevice[eleProp.field_name] = null
      //  }
    })
  }

  return newDevice
}

function _getLogicOp(logicUnit) {
  // 0xdead  且 and
  // 0xbeef  或 or
  // logic_op	0 无，1 AND， 2 OR
  if (!_.isEmpty(logicUnit) && !_.isNil(logicUnit._afterRelation)) {
    if (logicUnit._afterRelation == 0xdead) {
      // 57005
      return 1
    } else if (logicUnit._afterRelation == 0xbeef) {
      return 2
    }
  } else {
    return 0
  }
}

// /*FUN*/ _reGenerateMainId
function _reGenerateMainId(destArr, field_id) {
  destArr.forEach((ele, idx, arr) => {
    ele[field_id] = idx + 1

    if (field_id == 'scene_id') {
      ele['next_id_list'] = [idx + 2]

      if (idx == arr.length - 1) {
        ele['next_id_list'] = [destArr[0].scene_id]
      }
    }
  })

  // ④▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒④

  destArr.forEach(ele => {
    if (field_id == 'scene_id' && !_.isEmpty(ele['next_guid_list'])) {
      const eleFound_ = destArr.find(ele_ => ele_.scene_guid == ele['next_guid_list'][0])
      if (!_.isUndefined(eleFound_)) {
        ele['next_id_list'] = [eleFound_.scene_id]
      }
    }
  })
}

function _reGenerateMainId_device(deviceArr, field_id) {
  let sortedDeviceArr = []
  state.dj_category.forEach((eleDeviceCategory, idx, arr) => {
    sortedDeviceArr.push(
      deviceArr.filter((eleDevice, idx, arr) => {
        return eleDevice.device_type == eleDeviceCategory.type_
      }),
    )
  })

  // Added for sort @2024-10-02
  sortedDeviceArr.forEach((eleSortedDeviceArr, idx, arr) => {
    eleSortedDeviceArr.sort(function(a, b) {
      return a[field_id] - b[field_id]
    })
  })
  // Finished added for sort

  sortedDeviceArr.forEach((eleSortedDeviceArr, idx, arr) => {
    eleSortedDeviceArr.forEach((eleDevice, idx, arr) => {
      eleDevice[field_id] = idx + 1
    })
  })
}

// >>>1964>>> 2023-5-30
// 针对场景触发的动作，刷新param值
function _reGenerateSceneId_actionparam() {
  state.action_cells.forEach((eleActionCell, idx, arr) => {
    // 针对场景触发的动作，刷新param值
    if (eleActionCell.device_type === 39) {
      let found_scene = state.active_theme._sceneArr.filter(eleScene => {
        return eleScene.scene_guid === eleActionCell._param_value_uid
      })

      if (!_.isUndefined(found_scene) && !_.isUndefined(found_scene[0])) {
        eleActionCell.param = found_scene[0].scene_id
      } else {
        eleActionCell.param = -1
      }
    }
  })
}

function _updateRefId(srcArr, srcIdField, srcGuidField, destArr, destRefIdField, destRefGuidField, isArr) {
  if (isArr) {
    destArr.forEach((eleDest, idx, arr) => {
      eleDest[destRefIdField] = []
      eleDest[destRefGuidField].forEach((eleDestRefGuid, idx, arr) => {
        let foundSrc = srcArr.find((eleSrc, idx, arr) => {
          return eleSrc[srcGuidField] == eleDestRefGuid
        })
        if (!_.isUndefined(foundSrc)) {
          // 找到了!
          eleDest[destRefIdField].push(foundSrc[srcIdField])
        }
      })
    })
  } else {
    destArr.forEach((eleDest, idx, arr) => {
      if (!_.isEmpty(destRefGuidField)) {
        let foundSrc = srcArr.find((eleSrc, idx, arr) => {
          return eleSrc[srcGuidField] == eleDest[destRefGuidField]
        })
        if (!_.isUndefined(foundSrc)) {
          // 找到了!
          eleDest[destRefIdField] = foundSrc[srcIdField]
        }
      }
    })
  }
}

function _noDupPush(targetPool, item) {
  let field_guid = null
  for (const key in item) {
    if (item.hasOwnProperty(key)) {
      if (key.includes('_guid')) {
        field_guid = key
      }
    }
  }

  if (_.isNil(field_guid)) {
    return
  }

  let found = targetPool.find((ele, idx, arr) => {
    return ele[field_guid] == item[field_guid]
  })
  if (_.isUndefined(found)) {
    targetPool.push(item)
  }
}

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

// TODO 1101 _extrActionLogic
function _extrActionLogic(target) {
  if (!_.isEmpty(state.active_theme._sceneArr)) {
    state.active_theme._sceneArr.forEach((eleScene, idx, arr) => {
      // action_cells 收集在scene中用到的action_cell
      // action_list part1 收集上面action_cell对应的action_list
      _extrAction_frCACardArr(eleScene._inProgress_data.CACardArr, target)
      _extrAction_frActionBarArr(eleScene._onFinish_data.actionBarArr, target)
      _extrAction_frCACardArr(eleScene._onFinish_data.CACardArr, target)

      // logic_cells 收集在scene中用到的logic_cell
      // logic_units part1 收集上面logic_cell对应的logic_unit
      _extrLogic_frCardArr(eleScene._passScene_data.checkCardArr, target)
      _extrLogic_frCardArr(eleScene._inProgress_data.CACardArr, target)
      _extrLogic_frCardArr(eleScene._onFinish_data.CACardArr, target)
    })
  }
}

// FUNCTION _extrAction_frCACardArr
function _extrAction_frCACardArr(CACardArr, target, isAvoidDuplicate = true) {
  if (!_.isEmpty(CACardArr)) {
    CACardArr.forEach((eleCACard, idx, arr) => {
      if (!_.isEmpty(eleCACard) && !_.isEmpty(eleCACard.onTrue_actionBar) && !_.isEmpty(eleCACard.onTrue_actionBar.actions)) {
        eleCACard.onTrue_actionBar.actions.forEach((eleAction, idx, arr) => {
          if (!_.isEmpty(eleAction)) {
            _noDupPush(target.action_cells, eleAction)

            // TODO 1103 _noDupPush action_list不放到pool
            // _noDupPush(target.action_list, eleAction._action_list)
          }
        })
      }

      if (!_.isEmpty(eleCACard) && !_.isEmpty(eleCACard.onFalse_actionBar) && !_.isEmpty(eleCACard.onFalse_actionBar.actions)) {
        eleCACard.onFalse_actionBar.actions.forEach((eleAction, idx, arr) => {
          if (!_.isEmpty(eleAction)) {
            _noDupPush(target.action_cells, eleAction)

            // TODO 1103 _noDupPush action_list不放到pool
            // _noDupPush(target.action_list, eleAction._action_list)
          }
        })
      }
    })
  }
}

// FUNCTION _extrAction_frActionBarArr
function _extrAction_frActionBarArr(actionBarArr, target, isAvoidDuplicate = true) {
  if (!_.isEmpty(actionBarArr)) {
    actionBarArr.forEach((eleActionBar, idx, arr) => {
      if (!_.isEmpty(eleActionBar) && !_.isEmpty(eleActionBar.actions)) {
        eleActionBar.actions.forEach((eleAction, idx, arr) => {
          if (!_.isEmpty(eleAction)) {
            _noDupPush(target.action_cells, eleAction)

            // TODO 1103 不放到pool
            // _noDupPush(target.action_list, eleAction._action_list)
          }
        })
      }
    })
  }
}

// FUNCTION _extrLogic_frCardArr
// 可以从checkCard和CACard中获取
function _extrLogic_frCardArr(cardArr, target, isAvoidDuplicate = true) {
  if (!_.isEmpty(cardArr)) {
    cardArr.forEach((eleCard, idx, arr) => {
      if (!_.isEmpty(eleCard) && !_.isEmpty(eleCard.checkBarArr)) {
        eleCard.checkBarArr.forEach((eleCheckBar, idx, arr) => {
          if (!_.isEmpty(eleCheckBar) && !_.isEmpty(eleCheckBar.logicCellArr)) {
            eleCheckBar.logicCellArr.forEach((eleLogic, idx, arr) => {
              if (!_.isEmpty(eleLogic)) {
                _noDupPush(target.logic_cells, eleLogic)
                _noDupPush(target.logic_units, eleLogic._logic_unit)
              }
            })
          }
        })
      }
    })
  }
}

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

// FUNCTION _genAction_frCACardArr
// 除了"跳关",所有的actionCell在此时才生成actionList,包装不同的delay_tick
function _genAction_frCACardArr(CACardArr) {
  if (!_.isEmpty(CACardArr)) {
    CACardArr.forEach((eleCACard, idx, arr) => {
      if (!_.isEmpty(eleCACard) && !_.isEmpty(eleCACard.onTrue_actionBar) && !_.isEmpty(eleCACard.onTrue_actionBar.actions)) {
        let temp_action_list = {
          action_list_guid: uuidv4().toUpperCase(),
          action_list_name: eleCACard.onTrue_actionBar.actions
            .reduce(function (accumulator, currentValue, currentIndex, array) {
              return accumulator + ' , ' + currentValue.action_cell_name
            }, '')
            .slice(0, 31),

          action_list_desc: '',
          action_list_id: _gen_action_list_id(),

          exec_limit: 0,
          delay_tick: eleCACard.onTrue_actionBar.delay * 10,
          cell_count: eleCACard.onTrue_actionBar.actions.length,

          cell_list: eleCACard.onTrue_actionBar.actions.map((ele, idx, arr) => {
            return ele.action_cell_id
          }),
          _GUID_cell_list: eleCACard.onTrue_actionBar.actions.map((ele, idx, arr) => {
            return ele.action_cell_guid
          }),
        }

        _noDupPush(state.action_list_all, temp_action_list)
        _noDupPush(state.action_list, temp_action_list)

        eleCACard.onTrue_actionBar._action_list = temp_action_list
      } else {
        eleCACard.onTrue_actionBar._action_list = null
      }

      if (!_.isEmpty(eleCACard) && !_.isEmpty(eleCACard.onFalse_actionBar) && !_.isEmpty(eleCACard.onFalse_actionBar.actions)) {
        let temp_action_list = {
          action_list_guid: uuidv4().toUpperCase(),
          action_list_name: eleCACard.onFalse_actionBar.actions
            .reduce(function (accumulator, currentValue, currentIndex, array) {
              return accumulator + ' , ' + currentValue.action_cell_name
            }, '')
            .slice(0, 31),

          action_list_desc: '',
          action_list_id: _gen_action_list_id(),

          exec_limit: 0,
          delay_tick: eleCACard.onFalse_actionBar.delay * 10,
          cell_count: eleCACard.onFalse_actionBar.actions.length,

          cell_list: eleCACard.onFalse_actionBar.actions.map((ele, idx, arr) => {
            return ele.action_cell_id
          }),
          _GUID_cell_list: eleCACard.onFalse_actionBar.actions.map((ele, idx, arr) => {
            return ele.action_cell_guid
          }),
        }

        _noDupPush(state.action_list_all, temp_action_list)
        _noDupPush(state.action_list, temp_action_list)

        eleCACard.onFalse_actionBar._action_list = temp_action_list
      } else {
        eleCACard.onFalse_actionBar._action_list = null
      }
    })
  }
}

// FUNCTION _genAction_frActionBarArr
// 除了"跳关",所有的actionCell在此时才生成actionList,包装不同的delay_tick
function _genAction_frActionBarArr(actionBarArr) {
  if (!_.isEmpty(actionBarArr)) {
    actionBarArr.forEach((eleActionBar, idx, arr) => {
      if (!_.isEmpty(eleActionBar.actions)) {
        // TODO 1103 此处才生成action_list
        // if (eleActionBar.actions.length > 1) {
        let temp_action_list = {
          action_list_guid: uuidv4().toUpperCase(),
          action_list_name: eleActionBar.actions
            .reduce(function (accumulator, currentValue, currentIndex, array) {
              return accumulator + ' , ' + currentValue.action_cell_name
            }, '')
            .slice(0, 31),

          action_list_desc: '',
          action_list_id: _gen_action_list_id(),

          exec_limit: 0,
          delay_tick: eleActionBar.delay * 10,
          cell_count: eleActionBar.actions.length,

          cell_list: eleActionBar.actions.map((ele, idx, arr) => {
            return ele.action_cell_id
          }),
          _GUID_cell_list: eleActionBar.actions.map((ele, idx, arr) => {
            return ele.action_cell_guid
          }),
        }

        _noDupPush(state.action_list_all, temp_action_list)
        _noDupPush(state.action_list, temp_action_list)

        eleActionBar._action_list = temp_action_list
        // else if (eleActionBar.actions.length == 1) {
        //  // TODO 1102 _action_list 因为这里的action_list,是pool的拷贝体,所以需要对pool里的进行同步
        //  eleActionBar._action_list = eleActionBar.actions[0]._action_list
        //  eleActionBar._action_list.delay_tick = eleActionBar.delay * 10
        // }
      }
    })
  }
}

// FUNCTION _genLogic_frCheckCardArr
// 多了一层card之间的"或"
// 注意_afterRelation的处理,cell/bar
function _genLogic_frCheckCardArr(checkCardArr, parent) {
  if (!_.isEmpty(checkCardArr)) {
    checkCardArr.forEach((eleCheckCard, idx, arr) => {
      if (!_.isEmpty(eleCheckCard) && !_.isEmpty(eleCheckCard.checkBarArr)) {
        eleCheckCard.checkBarArr.forEach((eleCheckBar, idx, arr) => {
          if (!_.isEmpty(eleCheckBar) && !_.isEmpty(eleCheckBar.logicCellArr)) {
            if (eleCheckBar.logicCellArr.length > 1) {
              // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
              // logicCell之间
              eleCheckBar._logic_unit = eleCheckBar.logicCellArr.reduce(function (accuLogicUnit, curLogicCell, currentIndex, array) {
                if (currentIndex == 0) {
                  return accuLogicUnit
                }

                let temp_logic_group = {
                  logic_group_guid: uuidv4().toUpperCase(),
                  logic_group_name: (accuLogicUnit.logic_unit_name + ' , ' + curLogicCell._logic_unit.logic_unit_name).slice(0, 31),
                  logic_group_id: _gen_logic_group_id(),

                  logic_unit1_id: accuLogicUnit.logic_unit_id,
                  _GUID_logic_unit1_id: accuLogicUnit.logic_unit_guid,

                  logic_op: _getLogicOp(accuLogicUnit),

                  logic_unit2_id: curLogicCell._logic_unit.logic_unit_id,
                  _GUID_logic_unit2_id: curLogicCell._logic_unit.logic_unit_guid,
                }
                _noDupPush(state.logic_groups, temp_logic_group)

                // +++++++++++++++++++++++++++++++++++++++
                let temp_logic_unit = {
                  logic_unit_guid: uuidv4().toUpperCase(),
                  logic_unit_name: temp_logic_group.logic_group_name,
                  logic_unit_id: _gen_logic_unit_id(),

                  logic_unit_type: 2,

                  logic_cell_grp_id: temp_logic_group.logic_group_id,
                  _GUID_logic_cell_grp_id: temp_logic_group.logic_group_guid,

                  _afterRelation: curLogicCell._afterRelation, // 0xdead:且, 0xbeef:或
                }
                _noDupPush(state.logic_units, temp_logic_unit)
                return temp_logic_unit
              }, eleCheckBar.logicCellArr[0]._logic_unit)
            } else if (eleCheckBar.logicCellArr.length == 1) {
              eleCheckBar._logic_unit = _.cloneDeep(eleCheckBar.logicCellArr[0]._logic_unit)
            }
            // DUKU 注意,checkbar的后续逻辑关系
            eleCheckBar._logic_unit._afterRelation = eleCheckBar._afterRelation
          }
        })

        if (eleCheckCard.checkBarArr.length > 1) {
          // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
          // checkBar之间
          eleCheckCard._logic_unit = eleCheckCard.checkBarArr.reduce(function (accuLogicUnit, curCheckBar, currentIndex, array) {
            if (currentIndex == 0) {
              return accuLogicUnit
            }

            let temp_logic_group = {
              logic_group_guid: uuidv4().toUpperCase(),
              logic_group_name: (accuLogicUnit.logic_unit_name + ' , ' + curCheckBar._logic_unit.logic_unit_name).slice(0, 31),
              logic_group_id: _gen_logic_group_id(),

              logic_unit1_id: accuLogicUnit.logic_unit_id,
              _GUID_logic_unit1_id: accuLogicUnit.logic_unit_guid,

              // logic_op: 2, // logic_op	int	0 无，1 AND， 2 OR
              logic_op: _getLogicOp(accuLogicUnit),

              logic_unit2_id: curCheckBar._logic_unit.logic_unit_id,
              _GUID_logic_unit2_id: curCheckBar._logic_unit.logic_unit_guid,
            }
            _noDupPush(state.logic_groups, temp_logic_group)

            // +++++++++++++++++++++++++++++++++++++++
            let temp_logic_unit = {
              logic_unit_guid: uuidv4().toUpperCase(),
              logic_unit_name: temp_logic_group.logic_group_name,
              logic_unit_id: _gen_logic_unit_id(),

              logic_unit_type: 2,

              logic_cell_grp_id: temp_logic_group.logic_group_id,
              _GUID_logic_cell_grp_id: temp_logic_group.logic_group_guid,

              _afterRelation: curCheckBar._afterRelation, // 0xdead:且, 0xbeef:或
            }
            _noDupPush(state.logic_units, temp_logic_unit)
            return temp_logic_unit
          }, eleCheckCard.checkBarArr[0]._logic_unit)
        } else if (eleCheckCard.checkBarArr.length == 1) {
          eleCheckCard._logic_unit = _.cloneDeep(eleCheckCard.checkBarArr[0]._logic_unit)
        }
      }
    })

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // checkCard之间
    if (checkCardArr.length > 1) {
      parent._logic_unit = checkCardArr.reduce(function (accuLogicUnit, curCheckCard, currentIndex, array) {
        if (currentIndex == 0) {
          return accuLogicUnit
        }

        let temp_logic_group = {
          logic_group_guid: uuidv4().toUpperCase(),
          logic_group_name: (accuLogicUnit.logic_unit_name + ' , ' + curCheckCard._logic_unit.logic_unit_name).slice(0, 31),
          logic_group_id: _gen_logic_group_id(),

          logic_unit1_id: accuLogicUnit.logic_unit_id,
          _GUID_logic_unit1_id: accuLogicUnit.logic_unit_guid,

          logic_op: 2, // logic_op	int	0 无，1 AND， 2 OR checkCard之间只有逻辑"或"

          logic_unit2_id: curCheckCard._logic_unit.logic_unit_id,
          _GUID_logic_unit2_id: curCheckCard._logic_unit.logic_unit_guid,
        }

        _noDupPush(state.logic_groups, temp_logic_group)
        // +++++++++++++++++++++++++++++++++++++++
        let temp_logic_unit = {
          logic_unit_guid: uuidv4().toUpperCase(),
          logic_unit_name: temp_logic_group.logic_group_name,
          logic_unit_id: _gen_logic_unit_id(),

          logic_unit_type: 2,

          logic_cell_grp_id: temp_logic_group.logic_group_id,
          _GUID_logic_cell_grp_id: temp_logic_group.logic_group_guid,
        }

        _noDupPush(state.logic_units, temp_logic_unit)
        // +++++++++++++++++++++++++++++++++++++++
        return temp_logic_unit
      }, checkCardArr[0]._logic_unit)
    } else if (checkCardArr.length == 1) {
      parent._logic_unit = _.cloneDeep(checkCardArr[0]._logic_unit)
    }
  }
}

// FUNCTION _genLogic_frCACardArr
// 注意(_afterRelation)的处理,cell/bar
function _genLogic_frCACardArr(CACardArr) {
  if (!_.isEmpty(CACardArr)) {
    CACardArr.forEach((eleCACard, idx, arr) => {
      if (!_.isEmpty(eleCACard) && !_.isEmpty(eleCACard.checkBarArr)) {
        eleCACard.checkBarArr.forEach((eleCheckBar, idx, arr) => {
          if (!_.isEmpty(eleCheckBar) && !_.isEmpty(eleCheckBar.logicCellArr)) {
            if (eleCheckBar.logicCellArr.length > 1) {
              // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
              // logicCell之间
              eleCheckBar._logic_unit = eleCheckBar.logicCellArr.reduce(function (accuLogicUnit, curLogicCell, currentIndex, array) {
                if (currentIndex == 0) {
                  return accuLogicUnit
                }

                let temp_logic_group = {
                  logic_group_guid: uuidv4().toUpperCase(),
                  logic_group_name: (accuLogicUnit.logic_unit_name + ' , ' + curLogicCell._logic_unit.logic_unit_name).slice(0, 31),
                  logic_group_id: _gen_logic_group_id(),

                  logic_unit1_id: accuLogicUnit.logic_unit_id,
                  _GUID_logic_unit1_id: accuLogicUnit.logic_unit_guid,

                  // logic_op: 1, // logic_op	int	0 无，1 AND， 2 OR
                  logic_op: _getLogicOp(accuLogicUnit),

                  logic_unit2_id: curLogicCell._logic_unit.logic_unit_id,
                  _GUID_logic_unit2_id: curLogicCell._logic_unit.logic_unit_guid,
                }

                _noDupPush(state.logic_groups, temp_logic_group)
                // +++++++++++++++++++++++++++++++++++++++
                let temp_logic_unit = {
                  logic_unit_guid: uuidv4().toUpperCase(),
                  logic_unit_name: temp_logic_group.logic_group_name,
                  logic_unit_id: _gen_logic_unit_id(),

                  logic_unit_type: 2,

                  logic_cell_grp_id: temp_logic_group.logic_group_id,
                  _GUID_logic_cell_grp_id: temp_logic_group.logic_group_guid,

                  _afterRelation: curLogicCell._afterRelation,
                }

                _noDupPush(state.logic_units, temp_logic_unit)
                // +++++++++++++++++++++++++++++++++++++++
                return temp_logic_unit
              }, eleCheckBar.logicCellArr[0]._logic_unit)
              // +++++++++++++++++++++++++++++++++++++++
            } else if (eleCheckBar.logicCellArr.length == 1) {
              eleCheckBar._logic_unit = _.cloneDeep(eleCheckBar.logicCellArr[0]._logic_unit)
            }
            // DUKU 注意,checkbar的后续逻辑关系
            eleCheckBar._logic_unit._afterRelation = eleCheckBar._afterRelation
          }
        })

        if (eleCACard.checkBarArr.length > 1) {
          // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
          // checkBar之间
          eleCACard._logic_unit = eleCACard.checkBarArr.reduce(function (accuLogicUnit, curCheckBar, currentIndex, array) {
            if (currentIndex == 0) {
              return accuLogicUnit
            }

            let temp_logic_group = {
              logic_group_guid: uuidv4().toUpperCase(),
              logic_group_name: (accuLogicUnit.logic_unit_name + ' , ' + curCheckBar._logic_unit.logic_unit_name).slice(0, 31),
              logic_group_id: _gen_logic_group_id(),

              logic_unit1_id: accuLogicUnit.logic_unit_id,
              _GUID_logic_unit1_id: accuLogicUnit.logic_unit_guid,

              // logic_op: 2, // logic_op	int	0 无，1 AND， 2 OR
              logic_op: _getLogicOp(accuLogicUnit),

              logic_unit2_id: curCheckBar._logic_unit.logic_unit_id,
              _GUID_logic_unit2_id: curCheckBar._logic_unit.logic_unit_guid,
            }

            _noDupPush(state.logic_groups, temp_logic_group)
            // +++++++++++++++++++++++++++++++++++++++
            let temp_logic_unit = {
              logic_unit_guid: uuidv4().toUpperCase(),
              logic_unit_name: temp_logic_group.logic_group_name,
              logic_unit_id: _gen_logic_unit_id(),

              logic_unit_type: 2,

              logic_cell_grp_id: temp_logic_group.logic_group_id,
              _GUID_logic_cell_grp_id: temp_logic_group.logic_group_guid,

              _afterRelation: curCheckBar._afterRelation,
            }

            _noDupPush(state.logic_units, temp_logic_unit)
            // +++++++++++++++++++++++++++++++++++++++
            return temp_logic_unit
          }, eleCACard.checkBarArr[0]._logic_unit)
        } else if (eleCACard.checkBarArr.length == 1) {
          eleCACard._logic_unit = _.cloneDeep(eleCACard.checkBarArr[0]._logic_unit)
        }
      }
    })
  }
}

function _genCheckActionList_frCACardArr(CACardArr) {
  if (!_.isNil(CACardArr) && !_.isEmpty(CACardArr)) {
    CACardArr.forEach((eleCACard, idx, arr) => {
      // 一般的CACard
      // 必有checkBarArr
      // 必有onTrue_actionBar
      // 可选onFalse_actionBar
      if (
        !_.isNil(eleCACard) &&
        !_.isEmpty(eleCACard) &&
        !_.isNil(eleCACard.checkBarArr) &&
        !_.isEmpty(eleCACard.checkBarArr) &&
        !_.isNil(eleCACard.onTrue_actionBar) &&
        !_.isEmpty(eleCACard.onTrue_actionBar)
      ) {
        let temp_check_action = {
          check_action_guid: uuidv4().toUpperCase(),
          check_action_name: '',
          check_action_desc: '',
          check_action_id: _gen_check_action_id(),

          logic_unit_id: eleCACard._logic_unit.logic_unit_id, //  Cannot read property 'logic_unit_id' of undefined
          _GUID_logic_unit_id: eleCACard._logic_unit.logic_unit_guid,

          on_true_action_list: eleCACard.onTrue_actionBar._action_list.action_list_id,
          _GUID_on_true_action_list: eleCACard.onTrue_actionBar._action_list.action_list_guid,

          on_false_action_list: _.isNil(eleCACard.onFalse_actionBar._action_list) ? -1 : eleCACard.onFalse_actionBar._action_list.action_list_id,
          _GUID_on_false_action_list: _.isNil(eleCACard.onFalse_actionBar._action_list)
            ? null
            : eleCACard.onFalse_actionBar._action_list.action_list_guid,
        }

        _noDupPush(state.check_action_list, temp_check_action)

        eleCACard._check_action = temp_check_action
      }
    })
  }
}

function _genCheckActionList_frCheckCardArrParent(checkCardArrParent) {
  if (!_.isNil(checkCardArrParent) && !_.isNil(checkCardArrParent._logic_unit)) {
    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    let foundEleActionCell = state.action_cells.find((eleActionCell, idxActionCell, arrActionCell) => {
      return eleActionCell.device_type == 32
    })

    if (!_.isUndefined(foundEleActionCell)) {
      // 找到了!
    } else {
      // 没找到
      alert('没找到')
    }

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    let temp_check_action = {
      check_action_guid: uuidv4().toUpperCase(),
      check_action_name: '',
      check_action_desc: '',
      check_action_id: _gen_check_action_id(),

      logic_unit_id: checkCardArrParent._logic_unit.logic_unit_id,
      _GUID_logic_unit_id: checkCardArrParent._logic_unit.logic_unit_guid,

      on_true_action_list: foundEleActionCell._action_list.action_list_id, // 表示"通用跳关",仅用于过关判定
      on_false_action_list: -1,
    }

    _noDupPush(state.check_action_list, temp_check_action)

    checkCardArrParent._check_action = temp_check_action
  }
}

// TODO 1102 _genCheckActionList_frActionBarArr
function _genCheckActionList_frActionBarArr(actionBarArr) {
  if (!_.isNil(actionBarArr) && !_.isEmpty(actionBarArr)) {
    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    let foundEleLogicCell = state.logic_cells.find((eleLogicCell, idxLogicCell, arrLogicCell) => {
      return eleLogicCell.device_type == 31
    })

    if (!_.isUndefined(foundEleLogicCell)) {
      // 找到了!
    } else {
      // 没找到
      alert('没找到')
    }

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    actionBarArr.forEach((eleActionBar, idx, arr) => {
      // 一般的CACard
      // 必有checkBarArr
      // 必有onTrue_actionBar
      // 可选onFalse_actionBar
      let temp_check_action = {
        check_action_guid: uuidv4().toUpperCase(),
        check_action_name: '',
        check_action_desc: '',
        check_action_id: _gen_check_action_id(),

        logic_unit_id: foundEleLogicCell._logic_unit.logic_unit_id, // 表示"始终成立",相当于无条件,仅用于过关无条件动作

        on_true_action_list: eleActionBar._action_list.action_list_id,
        _GUID_on_true_action_list: eleActionBar._action_list.action_list_guid,

        on_false_action_list: -1,
      }

      _noDupPush(state.check_action_list, temp_check_action)

      eleActionBar._check_action = temp_check_action
    })
  }
}

function _genBoardScene(scene) {
  if (!_.isNil(scene) && !_.isEmpty(scene)) {
    // scene._passScene_data._check_action
    // scene._inProgress_data.CACardArr 中的每个元素有_check_action
    // scene._onFinish_data.actionBarArr 中的每个元素有_check_action
    // scene._onFinish_data.CACardArr 中的每个元素有_check_action

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    scene.check_action_list = []
    scene._GUID_check_action_list = []

    if (
      !_.isNil(scene._passScene_data) &&
      !_.isEmpty(scene._passScene_data) &&
      !_.isNil(scene._passScene_data._check_action) &&
      !_.isEmpty(scene._passScene_data._check_action)
    ) {
      scene.check_action_list.push(scene._passScene_data._check_action.check_action_id)
      scene._GUID_check_action_list.push(scene._passScene_data._check_action.check_action_guid)
    }

    scene._inProgress_data.CACardArr.forEach((eleCACard, idx, arr) => {
      if (!_.isNil(eleCACard._check_action) && !_.isEmpty(eleCACard._check_action)) {
        scene.check_action_list.push(eleCACard._check_action.check_action_id)
        scene._GUID_check_action_list.push(eleCACard._check_action.check_action_guid)
      }
    })

    scene.check_action_count = scene.check_action_list.length
    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    scene.on_finish_action_list = []
    scene._GUID_on_finish_action_list = []

    scene._onFinish_data.actionBarArr.forEach((eleActionBar, idx, arr) => {
      if (!_.isNil(eleActionBar._check_action) && !_.isEmpty(eleActionBar._check_action)) {
        scene.on_finish_action_list.push(eleActionBar._check_action.check_action_id)
        scene._GUID_on_finish_action_list.push(eleActionBar._check_action.check_action_guid)
      }
    })
    scene._onFinish_data.CACardArr.forEach((eleCACard, idx, arr) => {
      if (!_.isNil(eleCACard._check_action) && !_.isEmpty(eleCACard._check_action)) {
        scene.on_finish_action_list.push(eleCACard._check_action.check_action_id)
        scene._GUID_on_finish_action_list.push(eleCACard._check_action.check_action_guid)
      }
    })

    scene.on_finish_action_count = scene.on_finish_action_list.length
  }
}

// FUNCTION _genBoardTask
//  补全任务列表
//  确保第一个任务为“主任务”
function _ensureTaskArr(taskArr, sceneArr, targetLength = 128) {
  // 初始化为空数组（若为 null 或 undefined）
  if (_.isNil(taskArr) || _.isEmpty(taskArr)) {
    taskArr = [];
  }

  // 确保第一个任务为“主任务”
  taskArr[0] = {
    task_id: 1,
    task_name: taskArr[0] && taskArr[0].task_name ? taskArr[0].task_name : '主任务',
    task_name_id: taskArr[0] && taskArr[0].task_name_id ? taskArr[0].task_name_id : 'tn_task_1',
    scene: (sceneArr && sceneArr.length > 0) ? sceneArr[0] : null,
    // scene: firstScene,
    enabled: true,
  };

  // 补充存量任务缺失的 task_name_id（用 task_id 拼 key，不依赖数组顺序）
  for (let idx = 1; idx < taskArr.length; idx++) {
    if (!taskArr[idx].task_name_id) {
      taskArr[idx].task_name_id = 'tn_task_' + taskArr[idx].task_id
    }
  }

  // 补全后续任务
  for (let idx = taskArr.length; idx < targetLength; idx++) {
    taskArr.push({
      task_id: idx + 1,
      task_name: '任务' + (idx + 1),
      task_name_id: 'tn_task_' + (idx + 1),
      scene: null,
      enabled: false,
    });
  }

  return taskArr;
}

// /*FUN*/ _genBoardTheme
function _genBoardTheme(theme) {
  if (!_.isEmpty(theme)) {
    // ④▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒④ scene

    theme.theme_scene_list = []
    theme._GUID_theme_scene_list = []

    theme._sceneArr.forEach(eleScene => {
      theme.theme_scene_list.push(eleScene.scene_id)
      theme._GUID_theme_scene_list.push(eleScene.scene_guid)
    })
    theme.theme_scene_count = theme.theme_scene_list.length

    // ④▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒④ task

  theme.theme_task_list = []
  theme._taskArr.forEach((ele_task, idx_task) => {
    // console.log('ele_task: ', ele_task)
   if (idx_task == 0) {
    console.log('MAIN: ', idx_task, ele_task, theme._sceneArr)
    if (theme._sceneArr.length > 0) {
      theme.theme_task_list.push(theme._sceneArr[0].scene_id)
    } else {
      theme.theme_task_list.push(1)
    }
   } else if (ele_task.enabled && !_.isNil(ele_task.scene)) {
    //console.log('ACTIVE: ', idx_task, ele_task)
    const eleFd_scene = theme._sceneArr.find(ele_scene => ele_scene.scene_guid == ele_task.scene.scene_guid)
    if (!_.isUndefined(eleFd_scene)) {
     theme.theme_task_list.push(eleFd_scene.scene_id)
    } else {
      //console.log('ACTIVE- WARNING, NOSCENE')
     // alert('[1653017869]')
    }
   } else {
    //console.log('INAVTIVE: ', idx_task, ele_task)
    theme.theme_task_list.push(-1)
   }
  })
 }
}

// Fix task entry scene id issue
function _genBoardThemeTask(theme) {
  // ④▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒④ task
  theme.theme_task_list = []
  // console.log('_genBoardThemeTask - theme._taskArr ', theme._taskArr)
  theme._taskArr.forEach(ele_task => {
    if (ele_task.enabled && !_.isNil(ele_task.scene)) {
      // Update ref
      let foundSrc = state.active_theme._sceneArr.find((eleSrc, idx, arr) => {
        return eleSrc['scene_guid'] == ele_task.scene.scene_guid
      })

      if (!_.isUndefined(foundSrc)) {
        // 找到了!
        // console.log('Task ',ele_task.task_id,' found match scene', foundSrc['scene_id'], foundSrc)
        ele_task.scene.scene_id = foundSrc['scene_id']
      }
      // console.log('AVTIVE: ',  ele_task.task_id, ele_task.task_name, ele_task)
      theme.theme_task_list.push(ele_task.scene.scene_id)
    } else {
      // console.log('INAVTIVE: ',  ele_task.task_id, ele_task.task_name, ele_task)
      theme.theme_task_list.push(-1)
    }
  })
}

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

function _deleteField(data, isArr) {
  if (isArr) {
    data.forEach((ele, idx, arr) => {
      for (const key in ele) {
        if (ele.hasOwnProperty(key) && key.startsWith('_')) {
          delete ele[key]
        }
      }
    })
  } else {
    for (const key in data) {
      if (data.hasOwnProperty(key) && key.startsWith('_')) {
        delete data[key]
      }
    }
  }
}

function _genBoardDeviceLocalJson(theme) {
  if (!_.isEmpty(theme) && !_.isEmpty(theme._deviceArr)) {
    let toWriteData = {
      devices: _.cloneDeep(theme._deviceArr),
    }

    _deleteField(toWriteData.devices, true)

    // BEGIN: 重新归类和排序 @2024-10-02
    console.log('toWriteData.devices: ',toWriteData.devices)
    let sortedDeviceArr = []
    state.dj_category.forEach((eleDeviceCategory, idx, arr) => {
      sortedDeviceArr.push(
        toWriteData.devices.filter((eleDevice, idx, arr) => {
          return eleDevice.device_type == eleDeviceCategory.type_
        }),
      )
    })

    sortedDeviceArr.forEach((eleSortedDeviceArr, idx, arr) => {
      eleSortedDeviceArr.sort(function(a, b) {
        return a['device_id'] - b['device_id']
      })
    })

    console.log('sortedDeviceArr: ', sortedDeviceArr)

    let toWriteData2 =  {
      devices: [],
    }
    sortedDeviceArr.forEach((eleSortedDeviceArr) => {
      eleSortedDeviceArr.forEach((eleSortedDevice) => {
        toWriteData2.devices.push(eleSortedDevice)
      })
    })

    console.log('toWriteData.devices-2: ',toWriteData2.devices)
    // ENDS: 重新归类和排序

    // const data = JSON.stringify(toWriteData)
    const data = JSON.stringify(toWriteData2)
    const blob = new Blob([data], { type: '' })

    FileSaver.saveAs(blob, 'device.json')
  }
}

function _genBoardActionLocalJson(theme) {
  if (!_.isNil(theme) && !_.isEmpty(theme)) {
    let toWriteData = [
      { action_cells: _.cloneDeep(state.action_cells) },
      { action_list: _.cloneDeep(state.action_list) },
      { check_action_list: _.cloneDeep(state.check_action_list) },
    ]

    _deleteField(toWriteData[0].action_cells, true)
    _deleteField(toWriteData[1].action_list, true)
    _deleteField(toWriteData[2].check_action_list, true)

    const data = JSON.stringify(toWriteData)
    const blob = new Blob([data], { type: '' })
    FileSaver.saveAs(blob, 'action.json')
  }
}

function _genBoardLogicLocalJson(theme) {
  if (!_.isNil(theme) && !_.isEmpty(theme)) {
    let toWriteData = {
      logic_cells: _.cloneDeep(state.logic_cells),
      logic_units: _.cloneDeep(state.logic_units),
      logic_groups: _.cloneDeep(state.logic_groups),
    }

    _deleteField(toWriteData.logic_cells, true)
    _deleteField(toWriteData.logic_units, true)
    _deleteField(toWriteData.logic_groups, true)

    const data = JSON.stringify([toWriteData])
    const blob = new Blob([data], { type: '' })

    FileSaver.saveAs(blob, 'logic.json')
  }
}

function _genBoardSceneLocalJson(theme) {
  if (!_.isNil(theme) && !_.isEmpty(theme)) {
    let toWriteData = {
      scene_list: _.cloneDeep(theme._sceneArr),
    }

    _deleteField(toWriteData.scene_list, true)

    const data = JSON.stringify(toWriteData)
    const blob = new Blob([data], { type: '' })

    FileSaver.saveAs(blob, 'scene.json')
  }
}

function _genBoardThemeLocalJson(theme) {
  if (!_.isNil(theme) && !_.isEmpty(theme)) {
    let toWriteData = {
      theme_guid: theme.theme_guid,
      theme_name: theme.theme_name,
      theme_desc: theme.theme_desc,
      theme_fourcc: theme.theme_fourcc,
      theme_scene_count: theme.theme_scene_count,
      theme_scene_list: theme.theme_scene_list,
    }

    const data = JSON.stringify(toWriteData)
    const blob = new Blob([data], { type: '' })

    FileSaver.saveAs(blob, 'theme.json')
  }
}

function _genUIScene(theme) {
  if (!_.isEmpty(theme) && !_.isEmpty(theme._sceneArr)) {
    let toWriteData = {
      _sceneArr: _.cloneDeep(theme._sceneArr),
    }

    const data = JSON.stringify(toWriteData)
    const blob = new Blob([data], { type: '' })
    FileSaver.saveAs(blob, '_sceneArr.json')
  }
}

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

function _genBoardDeviceJsonAndSave(theme) {
  if (!_.isEmpty(theme) && !_.isEmpty(theme._deviceArr)) {
    let toWriteData = {
      devices: _.cloneDeep(theme._deviceArr),
    }

    _deleteField(toWriteData.devices, true)

    // BEGIN: 重新归类，根据device_id字段排序 @2024-10-02
    let sortedDeviceArr = []
    let field_name = 'device_id'
    state.dj_category.forEach((eleDeviceCategory, idx, arr) => {
      sortedDeviceArr.push(
        toWriteData.devices.filter((eleDevice, idx, arr) => {
          return eleDevice.device_type == eleDeviceCategory.type_
        }),
      )
    })

    sortedDeviceArr.forEach((eleSortedDeviceArr, idx, arr) => {
      eleSortedDeviceArr.sort(function(a, b) {
        return a[field_name] - b[field_name]
      })
    })

    let toWriteData2 =  {
      devices: [],
    }
    sortedDeviceArr.forEach((eleSortedDeviceArr) => {
      eleSortedDeviceArr.forEach((eleSortedDevice) => {
        toWriteData2.devices.push(eleSortedDevice)
      })
    })

    toWriteData = toWriteData2
    // ENDS: 重新归类和排序

    return JSON.stringify(toWriteData)
  }
}

function _genBoardActionJsonAndSave(theme) {
  if (!_.isNil(theme) && !_.isEmpty(theme)) {
    let toWriteData = [
      { action_cells: _.cloneDeep(state.action_cells) },
      { action_list: _.cloneDeep(state.action_list) },
      { check_action_list: _.cloneDeep(state.check_action_list) },
    ]

    _deleteField(toWriteData[0].action_cells, true)
    _deleteField(toWriteData[1].action_list, true)
    _deleteField(toWriteData[2].check_action_list, true)

    return JSON.stringify(toWriteData)
  }
}

function _genBoardLogicJsonAndSave(theme) {
  if (!_.isNil(theme) && !_.isEmpty(theme)) {
    let toWriteData = {
      logic_cells: _.cloneDeep(state.logic_cells),
      logic_units: _.cloneDeep(state.logic_units),
      logic_groups: _.cloneDeep(state.logic_groups),
    }

    _deleteField(toWriteData.logic_cells, true)
    _deleteField(toWriteData.logic_units, true)
    _deleteField(toWriteData.logic_groups, true)

    return JSON.stringify([toWriteData])
  }
}

function _genBoardSceneJsonAndSave(theme) {
  if (!_.isNil(theme) && !_.isEmpty(theme)) {
    let toWriteData = {
      scene_list: _.cloneDeep(theme._sceneArr),
    }

    _deleteField(toWriteData.scene_list, true)

    return JSON.stringify(toWriteData)
  }
}

// /*FUN*/ _genBoardThemeJsonAndSave
function _genBoardThemeJsonAndSave(theme) {
  if (!_.isNil(theme) && !_.isEmpty(theme)) {
    let toWriteData = {
      theme_guid: theme.theme_guid,
      theme_name: theme.theme_name,
      theme_desc: theme.theme_desc,
      theme_fourcc: theme.theme_fourcc,
      theme_scene_count: theme.theme_scene_count,
      theme_scene_list: theme.theme_scene_list,

      theme_task_list: theme.theme_task_list,
    }

    return JSON.stringify(toWriteData)
  }
}

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

function _expand_device_info(device) {
  // console.log('_gen_action_cell')
  // console.log(device)
  _gen_action_cell(device)
  // console.log('_gen_logic_cell')
  _gen_logic_cell(device)
}

function _gen_devcie_id(device_type) {
  let set_id = new Set()

  state.active_theme._deviceArr
    .filter((eleDevice, idx, arr) => {
      return eleDevice.device_type == device_type
    })
    .forEach((eleDevice, idx, arr) => {
      set_id.add(eleDevice.device_id)
    })

  for (let index = 1; index < 0xffffffff; index++) {
    if (!set_id.has(index)) {
      return index
    }
  }
}

function _gen_action_cell_id() {
  let set_id = new Set()
  state.action_cell_all.forEach((ele, idx, arr) => {
    set_id.add(ele.action_cell_id)
  })

  for (let index = 1; index < 0xffffffff; index++) {
    if (!set_id.has(index)) {
      return index
    }
  }
}

// /*FUN*/ _gen_action_cell
function _gen_action_cell(device) {

  let this_map_action_category = state.map_action_category.get(parseInt(device.device_type))
  if (_.isNil(this_map_action_category)) {
    return
  }

  this_map_action_category.action_types.forEach((eleActionType, idx, arr) => {

    let action_cell = {
      action_cell_guid: uuidv4().toUpperCase(),
      action_cell_name: device.device_name + ' ' + eleActionType.action_name,
      action_cell_desc: '',
      action_cell_id: _gen_action_cell_id(),

      device_type: device.device_type,

      device_id: device.device_id,
      _GUID_device_id: device.device_guid,

      device_op: eleActionType.action_value,

      param: 0,
      _param_enable: eleActionType.action_param,
      // 高级param编辑功能预留
      param_addtion: '',
      _param_hint: eleActionType.action_param_hint,
      _param_name: eleActionType.action_param_name,
      _param_edit_mode: eleActionType.action_param_mode,
      _isInEdit: false,

      // * 仅当 action cell的type=39
      // >>>1964>>> 2023-5-30
      _param_value_uid: null,  // 用于场景选择
    }

    // DUKU 此处不生成action_list了，在_genActionList时再生成,
    // 因为同一actionCell可能会有不同的delay,需用用不同的actionList来包装
    // _gen_action_list(action_cell)

    device._action_cells.push(action_cell)

    // console.log(`[modules/boarddata.js][1638503865][action_cell]▉`, action_cell)

    _noDupPush(state.action_cell_all, action_cell)
  })
}

function _gen_action_list_id() {
  let set_id = new Set()
  state.action_list_all.forEach((ele, idx, arr) => {
    set_id.add(ele.action_list_id)
  })

  for (let index = 1; index < 0xffffffff; index++) {
    if (!set_id.has(index)) {
      return index
    }
  }
}

function _gen_action_list(actionCell) {
  actionCell._action_list = {
    action_list_guid: uuidv4().toUpperCase(),
    action_list_name: actionCell.action_cell_name,
    action_list_desc: '',
    action_list_id: _gen_action_list_id(),

    exec_limit: 0,
    delay_tick: 0,
    cell_count: 1,

    cell_list: [actionCell.action_cell_id],
    _GUID_cell_list: [actionCell.action_cell_guid],
  }

  _noDupPush(state.action_list_all, actionCell._action_list)
}

function _gen_logic_cell_id() {
  let set_id = new Set()
  state.logic_cell_all.forEach((ele, idx, arr) => {
    set_id.add(ele.logic_cell_id)
  })

  for (let index = 1; index < 0xffffffff; index++) {
    if (!set_id.has(index)) {
      return index
    }
  }
}

// FUNCTION _gen_logic_cell
function _gen_logic_cell(device) {
  let this_map_logic_category = state.map_logic_category.get(parseInt(device.device_type))
  if (_.isNil(this_map_logic_category)) {
    return
  }

  this_map_logic_category.logic_types.forEach((eleLogicType, idx, arr) => {
    let logic_cell = {
      logic_cell_guid: uuidv4().toUpperCase(),
      logic_cell_name: device.device_name + ' ' + eleLogicType.logic_name,
      logic_cell_id: _gen_logic_cell_id(),

      device_type: device.device_type,

      device_id: device.device_id,
      _GUID_device_id: device.device_guid,

      logic_type: eleLogicType.logic_value,

      param: 0,
      _param_enable: eleLogicType.param_enable,

      _isInEdit: false,

      _afterRelation: 0xdead, // 0xdead:且, 0xbeef:或
    }

    // DUKU 还是要生成,因为同一logicCell的unit会被复用
    _gen_logic_unit(logic_cell)

    device._logic_cells.push(logic_cell)
    _noDupPush(state.logic_cell_all, logic_cell)
  })
}

function _gen_logic_unit_id() {
  let set_id = new Set()
  state.logic_unit_all.forEach((ele, idx, arr) => {
    set_id.add(ele.logic_unit_id)
  })

  for (let index = 1; index < 0xffffffff; index++) {
    if (!set_id.has(index)) {
      return index
    }
  }
}

function _gen_logic_group_id() {
  let set_id = new Set()
  state.logic_groups.forEach((ele, idx, arr) => {
    set_id.add(ele.logic_group_id)
  })

  for (let index = 1; index < 0xffffffff; index++) {
    if (!set_id.has(index)) {
      return index
    }
  }
}

function _gen_logic_unit(logicCell) {
  logicCell._logic_unit = {
    logic_unit_guid: uuidv4().toUpperCase(),
    logic_unit_name: logicCell.logic_cell_name,
    logic_unit_id: _gen_logic_unit_id(),
    logic_unit_type: 1,

    logic_cell_grp_id: logicCell.logic_cell_id,
    _GUID_logic_cell_grp_id: logicCell.logic_cell_guid,

    _afterRelation: logicCell._afterRelation, // 0xdead:且, 0xbeef:或
  }

  _noDupPush(state.logic_unit_all, logicCell._logic_unit)
}

function _gen_check_action_id() {
  let set_id = new Set()
  state.check_action_list.forEach((ele, idx, arr) => {
    set_id.add(ele.check_action_id)
  })

  for (let index = 1; index < 0xffffffff; index++) {
    if (!set_id.has(index)) {
      return index
    }
  }
}

function _gen_scene_id() {
  let set_id = new Set()
  state.active_theme._sceneArr.forEach((eleScene, idx, arr) => {
    set_id.add(eleScene.scene_id)
  })

  for (let index = 1; index < 0xffffffff; index++) {
    if (!set_id.has(index)) {
      return index
    }
  }
}

function _genSingleDeviceUsed(target, toCheckDevice) {
  let someRstActionCell = target.action_cells.some((eleActionCell, idxActionCell, arrActionCell) => {
    return eleActionCell._GUID_device_id == toCheckDevice.device_guid
  })

  let someRstLogicCell = target.logic_cells.some((eleLogicCell, idxLogicCell, arrLogicCell) => {
    return eleLogicCell._GUID_device_id == toCheckDevice.device_guid
  })

  if (someRstActionCell || someRstLogicCell) {
    toCheckDevice['isUsed'] = true
  } else {
    toCheckDevice['isUsed'] = false
  }
}

function _genIsDeviceUsed() {
  // Generate target
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  let target = {
    action_cells: [],
    action_list: [],
    logic_cells: [],
    logic_units: [],
  }
  _extrActionLogic(target)

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // check all device
  state.active_theme._deviceArr.forEach((eleDevice, idx, arr) => {
    _genSingleDeviceUsed(target, eleDevice)
  })
}

function saveAllJson() {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  /*
  let param = {
    device: _genBoardDeviceJsonAndSave(state.active_theme),
    action: _genBoardActionJsonAndSave(state.active_theme),
    logic: _genBoardLogicJsonAndSave(state.active_theme),
    scene: _genBoardSceneJsonAndSave(state.active_theme),
    theme: _genBoardThemeJsonAndSave(state.active_theme),
    themeId: state.active_theme.theme_guid,
    // board_guid: board_guid,
    // openid: store.getters.openid,

    themeScene: JSON.stringify(state.active_theme._sceneArr),
    themeDevice: JSON.stringify(state.active_theme._deviceArr),
    themeTask: JSON.stringify(state.active_theme._taskArr),
  }
  return api_boarddata.postThemeJson(param)
  */
  // console.log('in saveAllJson')
  return new Promise((resolve, reject) => {
    // 原始 JSON 构建逻辑
    const param = {
      device: _genBoardDeviceJsonAndSave(state.active_theme),
      action: _genBoardActionJsonAndSave(state.active_theme),
      logic: _genBoardLogicJsonAndSave(state.active_theme),
      scene: _genBoardSceneJsonAndSave(state.active_theme),
      theme: _genBoardThemeJsonAndSave(state.active_theme),
      themeId: state.active_theme.theme_guid,

      themeScene: JSON.stringify(state.active_theme._sceneArr),
      themeDevice: JSON.stringify(state.active_theme._deviceArr),
      themeTask: JSON.stringify(state.active_theme._taskArr),
      version: state.active_theme._version || 1,
      edition: state.active_theme._edition || 1
    };

    // console.log('state.active_theme._version', state.active_theme._version)
    if (_.isUndefined(state.active_theme._version)) {
      param.version = 100; // 默认版本
    }
    if (_.isUndefined(state.active_theme._edition)) {
      param.edition = 1; // 默认修订
    } else {
      param.edition = param.edition + 1
    }
    console.log('edition: ', param.edition);

    const worker = new GzipWorker();

    worker.postMessage(param); // 传给 worker 处理

    worker.onmessage = async (e) => {
      const compressedData = e.data;

      try {
        const res = await api_boarddata.postThemeJson(compressedData, {
          headers: {
            'Content-Encoding': 'gzip',
            'Content-Type': 'application/json'
          }
        });
        resolve(res);
      } catch (err) {
        console.error('上传失败：', err);
        reject(err);
      }

      worker.terminate();
    };

    worker.onerror = (err) => {
      console.error('Worker 错误：', err);
      worker.terminate();
      reject(err);
    };
  });
}

function extractGuids(arr) {
  return arr.map(item => {
    const guidKey = Object.keys(item).find(k => k.includes('_guid'))
    return guidKey ? item[guidKey] : JSON.stringify(item)
  }).sort()
}

function compareArrayContent(label, arr1, arr2) {
  const g1 = extractGuids(arr1)
  const g2 = extractGuids(arr2)
  const isEqual = JSON.stringify(g1) === JSON.stringify(g2)
  console.log(`✅ [${label}] 一致性: ${isEqual ? '✔一致' : '❌不一致'}`)
  if (!isEqual) {
    console.log('旧版:', g1)
    console.log('新版:', g2)
  }
  return isEqual
}


//const jsondiffpatch = window.jsondiffpatch || require('jsondiffpatch');
/**
 * 比较两份 JSON 数据并输出差异日志
 * @param {string} label - 标记此次比较的名称
 * @param {Object} oldData - 原始 JSON 数据
 * @param {Object} newData - 新 JSON 数据
 */
/*function runJsonDiffPatchTest(label, oldData, newData) {
  const diffpatcher = jsondiffpatch.create({
    objectHash: function (obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key) && key.toLowerCase().includes('_guid')) {
          return obj[key];
        }
      }
      return JSON.stringify(obj);
    },
    arrays: {
      detectMove: false
    }
  });

  const delta = diffpatcher.diff(oldData, newData);

  if (!delta) {
    console.log(`✅ [${label}] JSON 完全一致，无差异。`);
  } else {
    console.warn(`❗[${label}] 发现差异：`);
    console.log(JSON.stringify(delta, null, 2));
  }
}
*/


const jsondiffpatch = require('jsondiffpatch');

/**
 * 比较两份 JSON 并将差异以 HTML 格式输出到本地文件
 * @param {string} label - 文件名/标记（例如："action_list_all"）
 * @param {Object} oldData - 旧数据
 * @param {Object} newData - 新数据
 */
function runJsonDiffPatchTest(label, oldData, newData) {
  const diffpatcher = jsondiffpatch.create({
    objectHash: function (obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key) && key.toLowerCase().includes('_guid')) {
          return obj[key];
        }
      }
      return JSON.stringify(obj);
    },
    arrays: {
      detectMove: false
    }
  });

  const delta = diffpatcher.diff(oldData, newData);

  const htmlTitle = `Diff Report: ${label}`;
  let htmlBody = '';

  if (!delta) {
    // htmlBody = `<p style="color: green;">✅ [${label}] 无差异，完全一致。</p>`;
  } else {
    const fileName = `diff-${label.replace(/[^a-zA-Z0-9_-]/g, '_')}.html`;

    // 使用 file-saver 保存文件
    const blob = new Blob([delta], { type: 'text/html' });
    saveAs(blob, fileName);    
    console.log(`✅ 差异报告已导出到：${fileName}`);

    const baseFileName = `diff-${label.replace(/[^a-zA-Z0-9_-]/g, '_')}`;
    const oldDataFileName = `${baseFileName}-old.json`;
    const newDataFileName = `${baseFileName}-new.json`;
    // 保存旧的 JSON 数据
    const oldDataBlob = new Blob([JSON.stringify(oldData, null, 2)], { type: 'application/json' });
    saveAs(oldDataBlob, oldDataFileName);
    
    // 保存新的 JSON 数据
    const newDataBlob = new Blob([JSON.stringify(newData, null, 2)], { type: 'application/json' });
    saveAs(newDataBlob, newDataFileName);
  }

}


// import 'jsondiffpatch/public/formatters-styles/html.css'
// const formatters = require('jsondiffpatch/dist/formatters/html');
/**
 * 比较两份 JSON 并将差异以友好的 HTML 格式输出到本地文件
 * @param {string} label - 文件名/标记（例如："action_list_all"）
 * @param {Object} oldData - 旧数据
 * @param {Object} newData - 新数据
 */
// function runJsonDiffPatchTest(label, oldData, newData) {
//   const diffpatcher = jsondiffpatch.create({
//     objectHash: function (obj) {
//       for (let key in obj) {
//         if (obj.hasOwnProperty(key) && key.toLowerCase().includes('_guid')) {
//           return obj[key];
//         }
//       }
//       return JSON.stringify(obj);
//     },
//     arrays: { detectMove: false },
//   });

//   const delta = diffpatcher.diff(oldData, newData);

//   if (!delta) {
//     console.log(`✅ [${label}] 无差异，完全一致。`);
//     return;
//   }

//   // ✅ 使用独立引入的 formatters
//   const htmlBody = formatters.format(delta, oldData);

//   const htmlTitle = `Diff Report: ${label}`;
//   const htmlContent = `
// <!DOCTYPE html>
// <html lang="zh-CN">
// <head>
//   <meta charset="UTF-8">
//   <title>${htmlTitle}</title>
//   <!-- 使用 CDN 加载样式 -->
//   <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/jsondiffpatch/public/formatters-styles/html.css">
//   <style>
//     body {
//       font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;
//       background: #f5f7fa;
//       margin: 0;
//       padding: 20px;
//     }
//     h1 {
//       color: #2c3e50;
//       font-size: 20px;
//       margin-bottom: 20px;
//     }
//     .jsondiffpatch-delta {
//       background: white;
//       border-radius: 8px;
//       padding: 15px;
//       box-shadow: 0 0 6px rgba(0,0,0,0.1);
//     }
//   </style>
// </head>
// <body>
//   <h1>${htmlTitle}</h1>
//   <div class="jsondiffpatch-delta">
//     ${htmlBody}
//   </div>
// </body>
// </html>`;

//   const fileName = `diff-${label.replace(/[^a-zA-Z0-9_-]/g, '_')}.html`;
//   const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' });
//   saveAs(blob, fileName);

//   console.log(`✅ 差异报告已导出到：${fileName}`);
// }



function doGenerateAllJson(old = false) {
  // 2025-2-22 这里如果改为1呢
  // _refreshStorage(0)

  // console.log('doGenerateAllJson')
  // console.log('_refreshStorage begin')

  if (old) {
    _refreshStorage_old(1)
    // let oldActionList = _.cloneDeep(state.action_list_all)
    // let oldActionCell = _.cloneDeep(state.action_cell_all)
    // let oldLogicList = _.cloneDeep(state.logic_unit_all)
    // let oldLogicCell = _.cloneDeep(state.logic_cell_all)
  } else {
    _refreshStorage(1)
    // let newActionList = _.cloneDeep(state.action_list_all)
    // let newActionCell = _.cloneDeep(state.action_cell_all)
    // let newLogicList = _.cloneDeep(state.logic_unit_all)
    // let newLogicCell = _.cloneDeep(state.logic_cell_all)
  }
  // compareArrayContent('action_list_all', oldActionList, newActionList)
  // compareArrayContent('action_cell_all', oldActionCell, newActionCell)
  // compareArrayContent('logic_unit_all', oldLogicList, newLogicList)
  // compareArrayContent('logic_cell_all', oldLogicCell, newLogicCell)
  // console.log('_refreshStorage done')

  if (!_.isEmpty(state.active_theme._sceneArr)) {
    state.active_theme._sceneArr.forEach((eleScene, idx, arr) => {
      // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
      // Added by GUOJIULIN @2021/12/27
      // 完成时动作列表按照时间顺序重排
      if ((eleScene._onFinish_data) != null
        && (eleScene._onFinish_data.actionBarArr != null)
        && (eleScene._onFinish_data.actionBarArr.length > 1)) {
          eleScene._onFinish_data.actionBarArr.sort((a, b) => {return a.delay - b.delay})
      }

      // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
      //  action_cells 收集在scene中用到的action_cell
      //  action_list part1 收集上面action_cell对应的action_list
      _extrAction_frCACardArr(eleScene._inProgress_data.CACardArr, state)
      _extrAction_frActionBarArr(eleScene._onFinish_data.actionBarArr, state)
      _extrAction_frCACardArr(eleScene._onFinish_data.CACardArr, state)

      //  logic_cells 收集在scene中用到的logic_cell
      //  logic_units part1 收集上面logic_cell对应的logic_unit
      _extrLogic_frCardArr(eleScene._passScene_data.checkCardArr, state)
      _extrLogic_frCardArr(eleScene._inProgress_data.CACardArr, state)
      _extrLogic_frCardArr(eleScene._onFinish_data.CACardArr, state)

      // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
      //  action_list part2 收集action-bar里的生成的多aciton_cell组成的action_list
      _genAction_frCACardArr(eleScene._inProgress_data.CACardArr)
      _genAction_frActionBarArr(eleScene._onFinish_data.actionBarArr)
      _genAction_frCACardArr(eleScene._onFinish_data.CACardArr)

      //  logic_groups 收集check-bar里,logic_cells个数大于1的,组成的logic_group
      //  logic_units part2 收集上面logic_group对应的logic_unit
      _genLogic_frCheckCardArr(eleScene._passScene_data.checkCardArr, eleScene._passScene_data)
      _genLogic_frCACardArr(eleScene._inProgress_data.CACardArr)
      _genLogic_frCACardArr(eleScene._onFinish_data.CACardArr)

      // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
      //  check_action_list 收集logic_units + action_list的关联
      _genCheckActionList_frCheckCardArrParent(eleScene._passScene_data) // 要特殊处理的条件
      _genCheckActionList_frCACardArr(eleScene._inProgress_data.CACardArr)
      _genCheckActionList_frCACardArr(eleScene._onFinish_data.CACardArr)
      _genCheckActionList_frActionBarArr(eleScene._onFinish_data.actionBarArr) // 要特殊处理其中的无条件动作

      // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
      //  scene.check_action_count
      //  scene.check_action_list
      //  scene.on_finish_action_count
      //  scene.on_finish_action_list
      _genBoardScene(eleScene)
    })
  }

  // Added @ 2025-10-24
  // Fix issue 新主题首次下发，主任务的场景信息是空，场控无法加载
  _ensureTaskArr(state.active_theme._taskArr, state.active_theme._sceneArr)
  console.log('afer _ensureTaskArr', state.active_theme._taskArr)
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  //  theme.theme_scene_list
  //  theme.theme_scene_count

  _genBoardTheme(state.active_theme)

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ id重置
  // * 重置 device 里的 device_id
  // * 更新 action_cells 里的 device_id
  // * 更新 logic_cells 里的 device_id
  _reGenerateMainId_device(state.active_theme._deviceArr, 'device_id')

  // 因为device_id被重置,其下的各个cell里存储的device_id也需要被重置
  {
    state.active_theme._deviceArr.forEach((eleDevice, idxDevice, arrDevice) => {
      if (!_.isEmpty(eleDevice._logic_cells)) {
        eleDevice._logic_cells.forEach((eleLogicCell, idxLogicCell, arrLogicCell) => {
          eleLogicCell.device_id = eleDevice.device_id
        })
      }

      if (!_.isEmpty(eleDevice._action_cells)) {
        eleDevice._action_cells.forEach((eleActionCell, idxActionCell, arrActionCell) => {
          eleActionCell.device_id = eleDevice.device_id
        })
      }
    })
  }

  // 因为device_id被重置,_sceneArr的各个cell里存储的device_id也需要被重置
  {
    state.active_theme._sceneArr.forEach((eleScene, idxScene, arrScene) => {
      // eleScene._passScene_data.checkCardArr
      // eleScene._inProgress_data.CACardArr
      // eleScene._onFinish_data.actionBarArr
      // eleScene._onFinish_data.CACardArr
      // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
      if (!_.isEmpty(eleScene._passScene_data) && !_.isEmpty(eleScene._passScene_data.checkCardArr)) {
        eleScene._passScene_data.checkCardArr.forEach((eleCheckCard, idx, arr) => {
          if (!_.isEmpty(eleCheckCard.checkBarArr)) {
            eleCheckCard.checkBarArr.forEach((eleCheckBar, idx, arr) => {
              if (!_.isEmpty(eleCheckBar.logicCellArr)) {
                _updateRefId(state.active_theme._deviceArr, 'device_id', 'device_guid', eleCheckBar.logicCellArr, 'device_id', '_GUID_device_id')
              }
            })
          }
        })
      }
      // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
      if (!_.isEmpty(eleScene._inProgress_data) && !_.isEmpty(eleScene._inProgress_data.CACardArr)) {
        eleScene._inProgress_data.CACardArr.forEach((eleCACard, idx, arr) => {
          if (!_.isEmpty(eleCACard.checkBarArr)) {
            eleCACard.checkBarArr.forEach((eleCheckBar, idx, arr) => {
              if (!_.isEmpty(eleCheckBar.logicCellArr)) {
                _updateRefId(state.active_theme._deviceArr, 'device_id', 'device_guid', eleCheckBar.logicCellArr, 'device_id', '_GUID_device_id')
              }
            })
          }

          if (!_.isEmpty(eleCACard.onTrue_actionBar) && !_.isEmpty(eleCACard.onTrue_actionBar.actions)) {
            _updateRefId(
              state.active_theme._deviceArr,
              'device_id',
              'device_guid',
              eleCACard.onTrue_actionBar.actions,
              'device_id',
              '_GUID_device_id',
            )
          }

          if (!_.isEmpty(eleCACard.onFalse_actionBar) && !_.isEmpty(eleCACard.onFalse_actionBar.actions)) {
            _updateRefId(
              state.active_theme._deviceArr,
              'device_id',
              'device_guid',
              eleCACard.onFalse_actionBar.actions,
              'device_id',
              '_GUID_device_id',
            )
          }
        })
      }
      // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
      if (!_.isEmpty(eleScene._onFinish_data) && !_.isEmpty(eleScene._onFinish_data.actionBarArr)) {
        eleScene._onFinish_data.actionBarArr.forEach((eleActionBar, idx, arr) => {
          if (!_.isEmpty(eleActionBar.actions)) {
            _updateRefId(state.active_theme._deviceArr, 'device_id', 'device_guid', eleActionBar.actions, 'device_id', '_GUID_device_id')
          }
        })
      }
      // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
      if (!_.isEmpty(eleScene._onFinish_data) && !_.isEmpty(eleScene._onFinish_data.CACardArr)) {
        eleScene._onFinish_data.CACardArr.forEach((eleCACard, idx, arr) => {
          if (!_.isEmpty(eleCACard.checkBarArr)) {
            eleCACard.checkBarArr.forEach((eleCheckBar, idx, arr) => {
              if (!_.isEmpty(eleCheckBar.logicCellArr)) {
                _updateRefId(state.active_theme._deviceArr, 'device_id', 'device_guid', eleCheckBar.logicCellArr, 'device_id', '_GUID_device_id')
              }
            })
          }

          if (!_.isEmpty(eleCACard.onTrue_actionBar) && !_.isEmpty(eleCACard.onTrue_actionBar.actions)) {
            _updateRefId(
              state.active_theme._deviceArr,
              'device_id',
              'device_guid',
              eleCACard.onTrue_actionBar.actions,
              'device_id',
              '_GUID_device_id',
            )
          }

          if (!_.isEmpty(eleCACard.onFalse_actionBar) && !_.isEmpty(eleCACard.onFalse_actionBar.actions)) {
            _updateRefId(
              state.active_theme._deviceArr,
              'device_id',
              'device_guid',
              eleCACard.onFalse_actionBar.actions,
              'device_id',
              '_GUID_device_id',
            )
          }
        })
      }
    })
  }
  _updateRefId(state.active_theme._deviceArr, 'device_id', 'device_guid', state.action_cells, 'device_id', '_GUID_device_id')
  _updateRefId(state.active_theme._deviceArr, 'device_id', 'device_guid', state.logic_cells, 'device_id', '_GUID_device_id')

  // * 重置 action_cell 里的 action_cell_id
  // * 更新 action_list 里的 cell_list所包含的action_cell_id
  _reGenerateMainId(state.action_cells, 'action_cell_id')
  _updateRefId(state.action_cells, 'action_cell_id', 'action_cell_guid', state.action_list, 'cell_list', '_GUID_cell_list', true)

  // * 重置 action_list 里的 action_list_id
  // * 更新 check_action_list 里的 on_true_action_list/on_false_action_list
  _reGenerateMainId(state.action_list, 'action_list_id')
  _updateRefId(state.action_list, 'action_list_id', 'action_list_guid', state.check_action_list, 'on_true_action_list', '_GUID_on_true_action_list')
  _updateRefId(
    state.action_list,
    'action_list_id',
    'action_list_guid',
    state.check_action_list,
    'on_false_action_list',
    '_GUID_on_false_action_list',
  )

  // * 重置 logic_cell 里的 logic_cell_id
  // * 更新 logic_units 里的 logic_cell_grp_id 所对应的logic_cell_id（logic_unit_type: 1）
  _reGenerateMainId(state.logic_cells, 'logic_cell_id')
  _updateRefId(state.logic_cells, 'logic_cell_id', 'logic_cell_guid', state.logic_units, 'logic_cell_grp_id', '_GUID_logic_cell_grp_id')

  // * 重置 logic_groups 里的 logic_group_id
  // * 更新 logic_units 里的 logic_cell_grp_id所对应的logic_group_id（logic_unit_type: 2）
  _reGenerateMainId(state.logic_groups, 'logic_group_id')
  _updateRefId(state.logic_groups, 'logic_group_id', 'logic_group_guid', state.logic_units, 'logic_cell_grp_id', '_GUID_logic_cell_grp_id')

  // * 重置 logic_units 里的 logic_unit_id
  // * 更新 logic_groups 里的 logic_unit1_id/logic_unit2_id所对应的logic_unit_id
  // * 更新 check_action_list 里的 logic_unit_id
  _reGenerateMainId(state.logic_units, 'logic_unit_id')
  _updateRefId(state.logic_units, 'logic_unit_id', 'logic_unit_guid', state.logic_groups, 'logic_unit1_id', '_GUID_logic_unit1_id')
  _updateRefId(state.logic_units, 'logic_unit_id', 'logic_unit_guid', state.logic_groups, 'logic_unit2_id', '_GUID_logic_unit2_id')
  _updateRefId(state.logic_units, 'logic_unit_id', 'logic_unit_guid', state.check_action_list, 'logic_unit_id', '_GUID_logic_unit_id')

  // * 重置 check_action_list 里的 check_action_id
  // * 更新 scene_list 里的 check_action_list/on_finish_action_list所包含的check_action_id
  _reGenerateMainId(state.check_action_list, 'check_action_id')
  _updateRefId(
    state.check_action_list,
    'check_action_id',
    'check_action_guid',
    state.active_theme._sceneArr,
    'check_action_list',
    '_GUID_check_action_list',
    true,
  )
  _updateRefId(
    state.check_action_list,
    'check_action_id',
    'check_action_guid',
    state.active_theme._sceneArr,
    'on_finish_action_lis30t',
    '_GUID_on_finish_action_list',
    true,
  )

  // * 重置 scene_list 里的 scene_id
  // * 更新 theme.json 里的 theme_scene_list所包含的scene_id
  _reGenerateMainId(state.active_theme._sceneArr, 'scene_id')
  _updateRefId(state.active_theme._sceneArr, 'scene_id', 'scene_guid', [state.active_theme], 'theme_scene_list', '_GUID_theme_scene_list', true)

  // * 更新 state.action_cells的param 对scene id部分
  // * 仅当 action cell的type=39
  // >>>1964>>> TODO 2023-5-30
  _reGenerateSceneId_actionparam()

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // * 更新theme.json 里面 task list对应的scene id
  _genBoardThemeTask(state.active_theme)

  // console.log('after _genBoardThemeTask', state.active_theme.theme_task_list)

  _genIsDeviceUsed()
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // TEST 生成本地json文件
  // _genBoardDeviceLocalJson(state.active_theme)
  // _genBoardActionLocalJson(state.active_theme)
  // _genBoardLogicLocalJson(state.active_theme)
  // _genBoardSceneLocalJson(state.active_theme)
  // _genBoardThemeLocalJson(state.active_theme)
  // _genUIScene(state.active_theme)
}

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

// DUKU state
const state = {
  // +++++++++++++++++++++++++++++++++++++++ 本地配置数据加载,如各个种类,约定定义
  dj_category: null,
  map_dj_category: new Map(),

  action_category: null,
  map_action_category: new Map(),

  logic_category: null,
  map_logic_category: new Map(),

  // +++++++++++++++++++++++++++++++++++++++
  theme_list: null, // 所有的主题
  active_theme: null, // 选中要编辑的主题

  // +++++++++++++++++++++++++++++++++++++++ 激活的主题
  action_cell_all: [], // 池子：所有设备的
  action_list_all: [], // 池子：跳关 + action-bar生成的(要废弃了)

  logic_cell_all: [], // 池子：所有设备的
  logic_unit_all: [], // 池子：所有设备的 + check-bar/check-card/card-arr生成的

  action_cells: [], // 在场景中用到的
  action_list: [], // 1个跳关 + N个actionBar生成的(1个actionBar生成1个actionList)
  check_action_list: [], // 在场景中用到的,也是池子\也是生成的

  logic_cells: [], // 在场景中用到的
  logic_units: [], // 在场景中用到的 + 生成的
  logic_groups: [], // 在场景中用到的,也是池子 也是生成的

  // +++++++++++++++++++++++++++++++++++++++
  global_collapse: true,
  filer_board_name: '',
}

const mutations = {
  xxxxxxx: (state, data) => {},
}

const actions = {
  setGlobalCollapse({ commit }, val) {
    state.global_collapse = val
    if (val === true) {
      state.filer_board_name = ''
    }
  },

  setFilterBoardName({ commit }, val) {
    state.filer_board_name = val
  },

  prepareData({ commit }) {
    state.dj_category = getDjCategory()
    state.dj_category.forEach(eleCategory => {
      state.map_dj_category.set(parseInt(eleCategory.type_), eleCategory)
    })

    state.action_category = getActionCategory()
    state.map_action_category = new Map()
    state.action_category.forEach(eleCategory => {
      state.map_action_category.set(parseInt(eleCategory.dj_type), eleCategory)
    })

    state.logic_category = getLogicCategory()
    state.map_logic_category = new Map()
    state.logic_category.forEach(eleCategory => {
      state.map_logic_category.set(parseInt(eleCategory.dj_type), eleCategory)
    })

    state.theme_list = []
    api_boarddata
      .getThemeListOwn(store.getters.openid)
      .then(result => {
        if (result.code == 0) {
          result.data.forEach((eleTheme, idx, arr) => {
            let param = {
              theme_guid: eleTheme.theme_guid,
              theme_name: eleTheme.theme_name,
              theme_desc: eleTheme.theme_desc,
              theme_fourcc: eleTheme.fourcc,
              update_time: eleTheme.updateTime,
              _deviceArr: [],
              _sceneArr: [],
              _taskArr: [],
              _isOwn: true,
              _version: eleTheme.version || 1, // 版本号，默认为1
              _edition: eleTheme.edition || 1, // 修订号，默认1
              owner: eleTheme.owner,
            }
            console.log('getThemeListOwn: ', param)
            console.log('原始版本号: ', eleTheme.version)
            if (!_.isUndefined(eleTheme.version) && eleTheme.version == -1) {
              // console.log('getThemeListOwn: 版本号为-1, 需要设置默认版本号')
              param._version = 100
            }
            console.log('getThemeListOwn version: ', param._version)
            state.theme_list.push(param)
          })
        }

        return api_boarddata.getThemeListCoop(store.getters.openid)
      })
      .then(result => {
        if (result.code == 0) {
          result.data.forEach((eleTheme, idx, arr) => {
            let param = {
              theme_guid: eleTheme.theme_guid,
              theme_name: eleTheme.theme_name,
              theme_desc: eleTheme.theme_desc,
              theme_fourcc: eleTheme.fourcc,
              update_time: eleTheme.updateTime,
              _deviceArr: [],
              _sceneArr: [],
              _taskArr: [],
              _version: eleTheme.version || 1, // 版本号，默认为1
              _edition: eleTheme.edition || 1, // 修订号，默认1
              _isOwn: false,
            }

            if (!_.isUndefined(eleTheme.version) && eleTheme.version == -1) {
              // console.log('getThemeListCoop: 版本号为-1, 需要设置默认版本号')
              param._version = 100
            }
            // console.log('getThemeListCoop version: ', param._version)
            state.theme_list.push(param)
          })
        }
      })
  },

  // /*FUN*/ setActiveTheme
  // _theme 携带theme和是否升级的控制信息
  // {
  //   _theme:  // 原来的主题信息
  //   _upgrade: // 是否升级的控制信息
  // }
  setActiveTheme({ commit }, _theme) {
    let theme = _theme._theme
    let foundTheme = state.theme_list.find((eleTheme, idx, arr) => {
      return eleTheme.theme_guid == theme.theme_guid
    })
    if (!_.isUndefined(foundTheme)) {
      // 找到了!
      return api_boarddata
        .getThemeJson(theme.theme_guid)
        .then(result => {
          if (result.code == 0) {
            // ④▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒④ themeDevice
            if (!_.isEmpty(result.data.themeDevice)) {
              foundTheme._deviceArr = JSON.parse(result.data.themeDevice)
            } else {
              foundTheme._deviceArr = []
            }

            let filterRst_arrDevice = foundTheme._deviceArr.filter((eleDevice, idxDevice, arrDevice) => {
              return eleDevice.device_type == 3 && eleDevice.device_id == 11
            })
            // ④▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒④ themeScene

            if (!_.isEmpty(result.data.themeScene)) {
              foundTheme._sceneArr = JSON.parse(result.data.themeScene)
            } else {
              foundTheme._sceneArr = []
            }
            state.active_theme = foundTheme
            // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
            // Added by GUOJIULIN @2021/12/27
            // 完成时动作列表按照时间顺序重排
            if (state.active_theme._sceneArr != null && state.active_theme._sceneArr.length > 0) {
              state.active_theme._sceneArr.forEach((_scene, idx, arr) => {
                if ((_scene._onFinish_data) != null
                  && (_scene._onFinish_data.actionBarArr != null)
                  && (_scene._onFinish_data.actionBarArr.length > 1)) {
                  _scene._onFinish_data.actionBarArr.sort((a, b) => {return a.delay - b.delay})
                }
              })
            }

            // console.log(`[modules/boarddata.js][1638518077][foundTheme._sceneArr]▉`, foundTheme._sceneArr)

            // ④▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒④ themeTask
            // /*GEN*/ themeTask

            if (!_.isEmpty(result.data.themeTask) && _.size(result.data.themeTask) > 0) {
              // console.log('!_.isEmpty')
              foundTheme._taskArr = JSON.parse(result.data.themeTask)
              // console.log(foundTheme._taskArr)
            } else {
              // console.log('>>>自动补充task arr')
              foundTheme._taskArr = []
            }

            // Added @2025-4-8
            // 自动补充任务数量到128个
            foundTheme._taskArr = _ensureTaskArr(foundTheme._taskArr, foundTheme._sceneArr)
            // console.log('afer _ensureTaskArr', foundTheme._taskArr)
            // ④▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒④
            if (_theme._upgrade > 0) {
              _refreshStorage(1)
            } else {
              _refreshStorage(0)
            }

            _genIsDeviceUsed()

            return true
          } else {
            return false
          }
        })
        .catch(err => {})
    } else {
      alert('不应该出现这种情况!')
    }
  },

  // FUNCTION addTheme
  addTheme({ commit }, theme) {
    let param = {
      fourcc: theme.theme_fourcc,
      openid: store.getters.openid,
      theme_desc: theme.theme_desc,
      theme_name: theme.theme_name,
      theme_guid: '',
    }

    return api_boarddata
      .createOrModifyTheme(param)
      .then(result => {
        if (result.code == 0) {
          let param2 = {
            theme_guid: result.data.theme_guid,
            theme_name: result.data.theme_name,
            theme_desc: theme.theme_desc,
            theme_fourcc: theme.theme_fourcc,
            _isOwn: true,
            _deviceArr: [],
            _sceneArr: [],
            _taskArr: [],
          }
          _noDupPush(state.theme_list, param2)
          return true
        } else {
          return false
        }
      })
      .catch(err => {})
  },

  updateTheme({ commit }, theme) {
    let param = {
      fourcc: theme.theme_fourcc,
      openid: store.getters.openid,
      theme_desc: theme.theme_desc,
      theme_name: theme.theme_name,
      theme_guid: theme.theme_guid,
    }

    return api_boarddata
      .createOrModifyTheme(param)
      .then(result => {
        if (result.code == 0) {
          let foundThemeIdx = state.theme_list.findIndex((eleTheme, idx, arr) => {
            return eleTheme.theme_guid == result.data.theme_guid
          })
          if (foundThemeIdx !== -1) {
            // 找到了!
            state.theme_list[foundThemeIdx].theme_guid = result.data.theme_guid
            state.theme_list[foundThemeIdx].theme_name = result.data.theme_name
            state.theme_list[foundThemeIdx].theme_desc = result.data.theme_desc
            state.theme_list[foundThemeIdx].theme_fourcc = result.data.fourcc
          }
          return true
        } else {
          return false
        }
      })
      .catch(err => {})
  },

  // FUNCTION deleteTheme
  deleteTheme({ commit }, theme) {
    //  {
    //   "fourcc": "string",
    //   "openid": "string",
    //   "theme_desc": "string",
    //   "theme_name": "string",
    //   "theme_guid": "string"
    // }

    let param = {
      fourcc: theme.theme_fourcc,
      openid: store.getters.openid,
      theme_desc: theme.theme_desc,
      theme_name: theme.theme_name,
      theme_guid: theme.theme_guid,
    }

    return api_boarddata
      .deleleTheme(param)
      .then(result => {
        if (result.code == 0) {
          let foundThemeIdx = state.theme_list.findIndex((eleTheme, idx, arr) => {
            return eleTheme.theme_guid == result.data.theme_guid
          })
          if (foundThemeIdx !== -1) {
            // 找到了!
            state.theme_list.splice(foundThemeIdx, 1)
          }
          return true
        } else {
          return false
        }
      })
      .catch(err => {})
  },

  generateDevice({ commit }, device_type) {
    let newDevice = _genDevice(device_type)
    _expand_device_info(newDevice)
    _noDupPush(state.active_theme._deviceArr, newDevice)

    return newDevice
  },

  generateDeviceNoPush({ commit }, device_type) {
    let newDevice = _genDevice(device_type)
    _expand_device_info(newDevice)
    return newDevice
  },

  pushDevice({ commit }, device) {
    _noDupPush(state.active_theme._deviceArr, device)
    return device
  },

  delDevice({ commit }, toDelDevice) {
    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    // 1.检查action_cells中有没有(通过device_type和device_id来查找),若有则提示"场景XXX使用中,不能删除",若无则下一步
    // 2.检查logic_cells中有没有(通过device_type和device_id来查找),若有则提示"场景XXX使用中,不能删除",若无则下一步
    // 3.在action_cell_allDevices和logic_cells_allDevices中删除
    // 4.deviceArr中删除那个设备

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    let foundIdxDevice = state.active_theme._deviceArr.findIndex((eleDevice, idxDevice, arrDevice) => {
      return eleDevice.device_guid == toDelDevice.device_guid
    })
    if (foundIdxDevice !== -1) {
      // 找到了!
      state.active_theme._deviceArr[foundIdxDevice]
    } else {
      // 没找到
      alert('不应该!')
    }

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    let target = {
      action_cells: [],
      action_list: [],
      logic_cells: [],
      logic_units: [],
    }
    _extrActionLogic(target)

    console.log('toDelDevice', toDelDevice)
    console.log('actioncell', target.action_cells)

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    let someRstActionCell = target.action_cells.some((eleActionCell, idxActionCell, arrActionCell) => {
      return eleActionCell.device_type == toDelDevice.device_type && eleActionCell.device_id == toDelDevice.device_id
    })

    let someRstLogicCell = target.logic_cells.some((eleLogicCell, idxLogicCell, arrLogicCell) => {
      return eleLogicCell.device_type == toDelDevice.device_type && eleLogicCell.device_id == toDelDevice.device_id
    })

    if (someRstActionCell || someRstLogicCell) {
      // 至少有一个!
      return false
    } else {
      // 一个都没有
      state.active_theme._deviceArr.splice(foundIdxDevice, 1)
      return true
    }
  },
  isDeviceUsed({ commit }, toCheckDevice) {
    let foundIdxDevice = state.active_theme._deviceArr.findIndex((eleDevice, idxDevice, arrDevice) => {
      return eleDevice.device_guid == toCheckDevice.device_guid
    })
    if (foundIdxDevice !== -1) {
      // 找到了!
      state.active_theme._deviceArr[foundIdxDevice]
    } else {
      // 没找到
      alert('不应该!')
    }

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    let target = {
      action_cells: [],
      action_list: [],
      logic_cells: [],
      logic_units: [],
    }
    _extrActionLogic(target)

    // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
    let someRstActionCell = target.action_cells.some((eleActionCell, idxActionCell, arrActionCell) => {
      // return eleActionCell.device_type == toCheckDevice.device_type && eleActionCell.device_id == toCheckDevice.device_id
      return eleActionCell._GUID_device_id == toCheckDevice.device_id
    })

    let someRstLogicCell = target.logic_cells.some((eleLogicCell, idxLogicCell, arrLogicCell) => {
      // return eleLogicCell.device_type == toCheckDevice.device_type && eleLogicCell.device_id == toCheckDevice.device_id
      return eleLogicCell._GUID_device_id == toCheckDevice.device_id
    })

    if (someRstActionCell || someRstLogicCell) {
      return true
    }
    return false
  },
  generateScene({ commit }) {
    let scene_id_gend = _gen_scene_id()

    let newScene = {
      scene_guid: uuidv4().toUpperCase(),
      scene_name: '场景 ' + scene_id_gend,
      scene_desc: '',
      scene_id: scene_id_gend,

      next_count: 1,
      next_id_list: [8472], // 1: 最后一关

      duration_limit: 0,
      lock_time: 0,
      force_skip_on_timeout: 0,
      tae_id: 0,

      // check_action_count: 1,
      // check_action_list: [1],
      // on_finish_action_count: 1,
      // on_finish_action_list: [2],

      _passScene_data: {
        checkCardArr: [],
      },
      _inProgress_data: {
        CACardArr: [],
      },
      _onFinish_data: {
        actionBarArr: [],
        CACardArr: [],
      },
    }

    if (_.isEmpty(state.active_theme._sceneArr)) {
      newScene.next_id_list = [newScene.scene_id]
    } else {
      let lastScene = state.active_theme._sceneArr[state.active_theme._sceneArr.length - 1]
      lastScene.next_count = 1
      lastScene.next_id_list = [newScene.scene_id]

      newScene.next_id_list = [state.active_theme._sceneArr[0].scene_id]
    }

    _noDupPush(state.active_theme._sceneArr, newScene)
  },

  generateThemeUiSceneArrJsonFile({ commit }) {
    const data = JSON.stringify(state.active_theme._sceneArr)
    const blob = new Blob([data], { type: '' })
    FileSaver.saveAs(blob, state.active_theme.theme_guid + ' ' + 'ui_sceneArr.json')
  },

  // /*FUN*/ generateAllJson
  generatAllJson({ commit }) {
    doGenerateAllJson()
  },
  // /*FUN*/ generateAndSaveAllJson
  generateAndSaveAllJson({ commit }) {
    // doGenerateAllJson(true)
    // let result_old = {
    //   device: _genBoardDeviceJsonAndSave(state.active_theme),
    //   action: _genBoardActionJsonAndSave(state.active_theme),
    //   logic: _genBoardLogicJsonAndSave(state.active_theme),
    //   scene: _genBoardSceneJsonAndSave(state.active_theme),
    //   theme: _genBoardThemeJsonAndSave(state.active_theme)
    // }

    // doGenerateAllJson(false)
    // let result_new = {
    //   device: _genBoardDeviceJsonAndSave(state.active_theme),
    //   action: _genBoardActionJsonAndSave(state.active_theme),
    //   logic: _genBoardLogicJsonAndSave(state.active_theme),
    //   scene: _genBoardSceneJsonAndSave(state.active_theme),
    //   theme: _genBoardThemeJsonAndSave(state.active_theme)
    // }
    
    // runJsonDiffPatchTest('device', result_old.device, result_new.device)
    // runJsonDiffPatchTest('action', result_old.action, result_new.action)
    // runJsonDiffPatchTest('logic', result_old.logic, result_new.logic)
    // runJsonDiffPatchTest('scene', result_old.scene, result_new.scene)
    // runJsonDiffPatchTest('theme', result_old.theme, result_new.theme)
    // console.log('before - doGenerateAllJson')
    doGenerateAllJson()
    // console.log('after - doGenerateAllJson')
    return saveAllJson()
  },

  // FUNCTION issueToBoard 先存再发
  issueToBoard({ commit }, params) {
    return store.dispatch('boarddata/generateAndSaveAllJson').then(response => {
      // console.log('issueToBoard - save success, now download')
      return api_boarddata.issueToBoard({
        board_guid: params.board_guid,
        theme_guid: params.theme_guid,
        theme_index: params.theme_index,
        openid: store.getters.openid,
      })
    })
  },

  generateLogicUnit({ commit }, logic_cell) {
    return _gen_logic_unit(logic_cell)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// aaaaaaaaaaa({ commit }, theme_guid) {
//  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ active_theme deviceArr sceneArr
//  // 设置当前激活的主题,在ztbj页面,点击主题时调用,会从服务器获取这个主题的UI数据,包括deviceArr和sceneArr
//  // deviceArr: 要判断每个设备有无_action_cell和_logic_cell,若无则生成下,后面会保存到服务器上,就不需要再生成了
//  // sceneArr: 每个场景的_passScene_data/_inProgress_data/_onFinish_data,初始化为一些空值对象/数组,可以参考cjbj

//  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ 编辑一个设备
//  // 1.直接修改activeTheme._deviceArr[foundIdx]的相关属性,
//  // 2.若修改的是device_name,更新_action_cells中的action_cell_name
//  // 3.若修改的是device_name,更新_logic_cell的logic_cell_name
//  // 4.更新action_cell_allDevices
//  // 5.更新logic_cells_allDevices

//  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ 删除一个设备
//  // 1.检查action_cells中有没有(通过device_type和device_id来查找),若有则提示"场景XXX使用中,不能删除",若无则下一步
//  // 2.检查logic_cells中有没有(通过device_type和device_id来查找),若有则提示"场景XXX使用中,不能删除",若无则下一步
//  // 3.在action_cell_allDevices和logic_cells_allDevices中删除
//  // 4.deviceArr中删除那个设备

//  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ 生成theme.json
//  // api getUiDataByThemeGUID(theme_guid)
//  state.active_theme = {
//   theme_guid: '53999712-5F83-458E-9E2D-7980A394BFB5',
//   theme_name: '末日办公楼',
//   theme_desc: '大连改版',
//   theme_fourcc: 'MRBD',
//   // theme_scene_count: 32,
//   // theme_scene_list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32],

//   // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ 生成scene.json
//   _sceneArr: [
//    {
//     scene_guid: '9DC376A5-A878-4C7B-922F-7C7AAC476013',
//     scene_name: '收房间',
//     scene_desc: '',
//     scene_id: 2,
//     next_count: 1,
//     next_id_list: [3],
//     lock_time: 0,
//     duration_limit: 0,
//     force_skip_on_timeout: 0,
//     tae_id: 1,
//     // check_action_count: 5,
//     // check_action_list: [90, 91, 92, 93, 94],
//     // on_finish_action_count: 4,
//     // on_finish_action_list: [95, 96, 97, 98],

//     _passScene_data: {},
//     _inProgress_data: {},
//     _onFinish_data: {},
//    },
//   ],

//   // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ 生成device.json
//   _deviceArr: [
//    {
//     device_guid: '06BC752F-D90B-4110-AEFF-3A3F57623F13',
//     device_name: '肋骨机关',
//     device_desc: '串联模式',
//     device_type: 1,
//     device_id: 1,

//     power_io: -1,
//     start_io: -1,
//     stop_io: -1,
//     result_io: 6,
//     ck_io: 7,
//     work_mode: 0,
//     fail_wait: 0,
//     input_io_count: 0,
//     input_io_list: [],
//     output_io_count: 0,
//     output_io_list: [],
//     on_fail_ae: 0,
//     on_success_ae: 0,

//     _action_cells: [
//      {
//       action_cell_guid: 'B8EC7A07-9966-4FB2-9220-54BCFE2F99F9',
//       action_cell_name: '肋骨机关供电 启动',
//       action_cell_desc: '',
//       action_cell_id: 3,
//       device_type: 4,
//       device_id: 1,
//       device_op: 1,
//      },
//     ],

//     _logic_cells: [
//      {
//       logic_cell_guid: 'B50D95AB-2571-4F2E-89B2-6EEBFC44DEB5',
//       logic_cell_name: '肋骨机关 成功',
//       logic_cell_id: 3,
//       device_type: 1,
//       device_id: 1,
//       logic_type: true,
//      },
//     ],
//    },
//   ],
//  }

//  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ 仅做池子用
//  // 页面beforeEach时初始化,由所有device的_action_cell组成,把activeTheme中的所有设备的所有_action_cell存入这里
//  state.action_cell_all = []

//  // 页面beforeEach时初始化,由所有device的_logic_cell组成,把activeTheme中的所有设备的所有_logic_cell存入这里
//  state.logic_cell_all = []

//  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ 生成action.json
//  // 进入一个主题的场景编辑界面时初始化为[]
//  // cjbj中点"保存"时,根据action-bar使用情况拷贝于action_cell_allDevices,参考action_list,整体覆盖
//  state.action_cells = []

//  // 进入一个主题的场景编辑界面时初始化为[],
//  // cjbj中点"保存"时,由action-bar生成,其对应的action_cell先要生成action_list(cell_count为1),并放到action_cells中,整体覆盖
//  state.action_list = []

//  // 进入一个主题的场景编辑界面时初始化为[]
//  // cjbj中点"保存"时生成,整体覆盖
//  state.check_action_list = []

//  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ 生成logic.json
//  // 进入一个主题的场景编辑界面时初始化为[]
//  // cjbj中点"保存"时,拷贝于logic_cells_allDevices,参考logic_units,整体覆盖
//  state.logic_cells = []

//  // 进入一个主题的场景编辑界面时初始化为[]
//  // cjbj中点"保存"时,由check-bar生成,其对应的logic_cell先要生成logic_unit(logic_unit_type为1),并放到logic_cells中,整体覆盖
//  state.logic_units = []

//  // 进入一个主题的场景编辑界面时初始化为[]
//  // cjbj中点"保存"时去生成,整体覆盖
//  state.logic_groups = []

//  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

//  commit('SET_TOKEN', null)
//  commit('SET_ROLES', null)
//  commit('SET_USERNAME', null)
//  commit('SET_USER_ROUTES', null)
//  commit('SET_USER', null)
//  commit('SET_HAS_ASYNC_ROUTE', false)
// },
